import { API_URL, MV_API_URL } from '~/config';
import { apiTags, API_FRONTEND_ACCESS_URL } from './APIDocConstants';
import File_Upload_IMG from '~/assets/file_upload_media.png';
const { TABLE, JSON, H3, H4, P, A, IMG } = apiTags;


export const getCommandcenterData = () => ({
  sidebarLinks: {
    Authentication: {
      chlidLinks: {
        "Authorization": {
          title: 'Authorization',
          parentTags: [
            {
              P: {
                detail: "To verify incoming API requests, Brightlink's APIs use access tokens, these access tokens are handled by JWT.The API uses JWT access tokens to access all secure endpoints. Access tokens can be requested via the end point as detailed below. The access token is required as a Bearer token for all the other APIs."
              }
            }
          ]
        },
        "Permission": {
          title: 'Permission',
          parentTags: [
            {
              P: {
                detail: "The permissions of an access token will be based upon the client that requested the token. The access token is issued against a user account in the Brightlink portal. The API access permissions will mirror the permissions set for the user in the portal."
              }
            }
          ]
        },
        "Obtaining Access Token": {
          title: 'Obtaining an Access Token',
          parentTags: [
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/login`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Content-Type: application/json']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `Enter a valid email that is registered to the CommandCenter.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'test@gmail.com']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`password`, `Description`, `Enter a valid password.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Test@1234']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`remember_me`, `Description`, `Remember the access Token for 1 Month.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true/false']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "email": "test@gmail.com",
                      "password": "Test@1234",
                      "remember_me": true
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "id": "2cd8ead5-fa2a-43dc-bf92-2e74beb40e52",
                        "first_name": "",
                        "last_name": "Test",
                        "title": "",
                        "name": "Test",
                        "email": "test@gmail.com",
                        "status": 1,
                        "must_change_password": false,
                        "password_reset_token": null,
                        "user_level": "administrator",
                        "send_email_invite": true,
                        "is_deleted": false,
                        "created": "2020-01-23T13:49:47.673Z",
                        "recent_activity": "2021-01-13T13:34:04.000Z",
                        "parent": "8373f849-2ab4-43fe-be03-921bf6e30927",
                        "roles": [],
                        "reseller": null,
                        "customer": null,
                        "contact": null,
                        "agreement": null,
                        "rememberMe": true,
                        "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiIyY2Q4ZWFkNS1mYTJhLTQzZGMtYmY5Mi0yZTc0YmViNDBlNTIiLCJyZW1lbWJlck1lIjp0cnVlLCJpYXQiOjE2MTA1NDQ4NDQsImV4cCI6MTYxMzEzNjg0NH0.4SJ7mQWqEVnk96vS98tjM3wTfvvC07rHh6mgxTh0JjQ"
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`status_code`, `Description`, `HTTP response status codes indicate whether a specific HTTP request has been successfully completed.`]
                      },
                      {
                        columns: ['Type', 'Number']
                      },
                      {
                        columns: ['Example', 200]
                      },
                      {
                        rowSpan: 4,
                        columns: [`token`, `Description`, `The access token to send in the Authorization Bearer header.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiIyY2Q4ZWFkNS1mYTJhLTQzZGMtYmY5Mi0yZTc0YmViNDBlNTIiLCJyZW1lbWJlck1lIjp0cnVlLCJpYXQiOjE2MTA1NDQ4NDQsImV4cCI6MTYxMzEzNjg0NH0.4SJ7mQWqEVnk96vS98tjM3wTfvvC07rHh6mgxTh0JjQ']
                      }
                    ]
                  }
                ]
              }
            },
          ]
        },
      }
    },
    Read: {
      chlidLinks: {
        "Customer List": {
          title: 'Customer List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Customers List associated with the Partner."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/users/customers/{parentId}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['parentId', `Description`, `Partner ID is required for fetching Customers List.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'aa040c41-4209-44d9-92f3-2d72d75da287']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/users/customers/aa040c41-4209-44d9-92f3-2d72d75da287`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": [
                        {
                          "id": "095696de-d804-4f26-9b48-5f9ce4173df0",
                          "name": "Customer Content",
                          "status": 1,
                          "user_level": "customer",
                          "reseller_name": "1Trial Partner Content Fix",
                          "created": "2019-07-24T11:34:26.350Z",
                          "recent_activity": "2019-07-24T11:34:26.350Z",
                          "reseller_id": "aa040c41-4209-44d9-92f3-2d72d75da287",
                          "contact": {
                            "admin_contact": "",
                            "admin_email": "",
                            "admin_phone": "",
                            "billing_contact": "",
                            "billing_email": "",
                            "billing_phone": "",
                            "primary_contact": "CONTENT CHECK",
                            "primary_email": "1111@coin-mail.com",
                            "primary_phone": "342342343"
                          },
                          "phone_cnt": 0,
                          "user_cnt": 0
                        },
                        {
                          "id": "94ae7ebf-2092-4383-89be-f71a8b8d7fd1",
                          "name": "Double Check Tab Content",
                          "status": 1,
                          "user_level": "customer",
                          "reseller_name": "1Trial Partner Content Fix",
                          "created": "2019-07-24T12:19:36.952Z",
                          "recent_activity": "2019-07-24T12:19:36.952Z",
                          "reseller_id": "aa040c41-4209-44d9-92f3-2d72d75da287",
                          "contact": {
                            "admin_contact": "",
                            "admin_email": "",
                            "admin_phone": "",
                            "billing_contact": "",
                            "billing_email": "",
                            "billing_phone": "",
                            "primary_contact": "QA1",
                            "primary_email": "1234111@coin-mail.com",
                            "primary_phone": "2343245"
                          },
                          "phone_cnt": 3,
                          "user_cnt": 3
                        },
                        {
                          "id": "3556a87c-33b0-4ae6-a17f-74d5bd1bc9a7",
                          "name": "Fix Content RANCHER",
                          "status": 1,
                          "user_level": "customer",
                          "reseller_name": "1Trial Partner Content Fix",
                          "created": "2019-07-24T12:14:42.994Z",
                          "recent_activity": "2019-07-24T12:14:42.994Z",
                          "reseller_id": "aa040c41-4209-44d9-92f3-2d72d75da287",
                          "contact": {
                            "admin_contact": "",
                            "admin_email": "",
                            "admin_phone": "",
                            "billing_contact": "",
                            "billing_email": "",
                            "billing_phone": "",
                            "primary_contact": "QA",
                            "primary_email": "11111@coin-mail.com",
                            "primary_phone": "23432423432"
                          },
                          "phone_cnt": 0,
                          "user_cnt": 0
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of Customer.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '095696de-d804-4f26-9b48-5f9ce4173df0']
                      },
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Name of Customer.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Customer Content']
                      },
                      {
                        rowSpan: 3,
                        columns: ['reseller_id', `Description`, `ID of Partner.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'aa040c41-4209-44d9-92f3-2d72d75da287']
                      },
                      {
                        rowSpan: 3,
                        columns: ['reseller_name', `Description`, `Name of Partner.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '1Trial Partner Content Fix']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_cnt', `Description`, `Count of Phone Numbers associated with the customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 2]
                      },
                      {
                        rowSpan: 3,
                        columns: ['user_cnt', `Description`, `Count of Users associated with the customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 3]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Customer Details By ID": {
          title: 'Customer Details By ID',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Customer Details by ID."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/customer/{customerId}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customerId', `Description`, `Customer ID is required for fetching Customer Details.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '7f552eda-8b43-414a-a58e-d22fbf44debb']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/customer/7f552eda-8b43-414a-a58e-d22fbf44debb`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "id": "7f552eda-8b43-414a-a58e-d22fbf44debb",
                        "name": "Voxtell",
                        "status": 1,
                        "user_level": "customer",
                        "reseller_name": "Voxtell",
                        "created": "2020-06-18T15:29:01.833Z",
                        "recent_activity": "2020-06-18T15:29:01.833Z",
                        "reseller_id": "755ab5e3-797a-4401-bde6-e4afd3c46697",
                        "contact": {
                          "admin_contact": "Junior Smizmaul",
                          "admin_email": "hi@voxtell.com",
                          "admin_phone": "4072888142",
                          "billing_contact": "Junior Smizmaul",
                          "billing_email": "hi@voxtell.com",
                          "billing_phone": "4072888142",
                          "primary_contact": "Junior Smizmaul",
                          "primary_email": "hi@voxtell.com",
                          "primary_phone": "4072888142"
                        },
                        "phone_cnt": 1,
                        "user_cnt": 1
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of Customer.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '7f552eda-8b43-414a-a58e-d22fbf44debb']
                      },
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Name of Customer.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Voxtell']
                      },
                      {
                        rowSpan: 3,
                        columns: ['reseller_id', `Description`, `ID of Partner.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '755ab5e3-797a-4401-bde6-e4afd3c46697']
                      },
                      {
                        rowSpan: 3,
                        columns: ['reseller_name', `Description`, `Name of Partner.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Voxtell']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_cnt', `Description`, `Count of Phone Numbers associated with the customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      },
                      {
                        rowSpan: 3,
                        columns: ['user_cnt', `Description`, `Count of Users associated with the customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "User List": {
          title: 'Users List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Users List associated with the Customer."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/messageview/users/{customer_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customer_id', `Description`, `Customer ID is required for fetching Users List.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '9ca8cbca-08e5-4547-a950-fe4842f77fe8']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/messageview/users/9ca8cbca-08e5-4547-a950-fe4842f77fe8`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": [
                        {
                          "id": "515ce094-6635-4208-ac18-65ba5013366a",
                          "email": "hbergman@advancedvoipsolutions.com",
                          "must_change_password": false,
                          "first_name": "Hayden",
                          "last_name": "Bergman",
                          "title": "Account Executive",
                          "default_phone_id": 217,
                          "created": "2019-11-11T13:28:51.551Z",
                          "show_censor_contact": true,
                          "phones": [
                            {
                              "id": 220,
                              "phone_number": "12023186840",
                              "title": "Support",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:45.497Z",
                              "rateOfSend": 1
                            },
                            {
                              "id": 217,
                              "phone_number": "12023187094",
                              "title": "Hayden Bergman",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:55:53.157Z",
                              "rateOfSend": 1
                            }
                          ],
                          "password_changed_at": "2021-01-20T06:41:01.204Z",
                          "passwords": [],
                          "isPasswordExpired": false
                        },
                        {
                          "id": "e96ab4f6-586c-4499-bf60-d29513e8763c",
                          "email": "nlee@advancedvoipsolutions.com",
                          "must_change_password": false,
                          "first_name": "Nate",
                          "last_name": "Lee",
                          "title": "Spin Doctor",
                          "default_phone_id": 219,
                          "created": "2019-11-11T13:28:51.551Z",
                          "show_censor_contact": false,
                          "phones": [
                            {
                              "id": 221,
                              "phone_number": "12023187079",
                              "title": "Marketing",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:57:00.538Z",
                              "rateOfSend": 1
                            },
                            {
                              "id": 220,
                              "phone_number": "12023186840",
                              "title": "Support",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:45.497Z",
                              "rateOfSend": 1
                            },
                            {
                              "id": 219,
                              "phone_number": "12023186839",
                              "title": "Nate Lee",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:28.276Z",
                              "rateOfSend": 1
                            }
                          ],
                          "password_changed_at": "2021-01-20T06:41:01.204Z",
                          "passwords": [],
                          "isPasswordExpired": false
                        },
                        {
                          "id": "24ed90d7-94bc-4c45-a4af-5e42cf7fbf39",
                          "email": "nitesh.test12@gmail.com",
                          "must_change_password": true,
                          "first_name": "Nitesh12",
                          "last_name": "Test",
                          "title": "title",
                          "default_phone_id": 219,
                          "created": "2021-01-18T06:21:56.333Z",
                          "show_censor_contact": true,
                          "phones": [
                            {
                              "id": 218,
                              "phone_number": "12023186607",
                              "title": "Paul Kidd",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:09.958Z",
                              "rateOfSend": 2
                            },
                            {
                              "id": 219,
                              "phone_number": "12023186839",
                              "title": "Nate Lee",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:28.276Z",
                              "rateOfSend": 1
                            }
                          ],
                          "password_changed_at": "2021-01-20T06:41:01.204Z",
                          "passwords": [],
                          "isPasswordExpired": false
                        },
                        {
                          "id": "4e5b5038-e189-4426-8dcb-f7d59aefdb57",
                          "email": "pkidd@advancedvoipsolutions.com",
                          "must_change_password": false,
                          "first_name": "Paul",
                          "last_name": "Kidd",
                          "title": "Rock Star",
                          "default_phone_id": 218,
                          "created": "2019-11-11T13:28:51.551Z",
                          "show_censor_contact": false,
                          "phones": [
                            {
                              "id": 221,
                              "phone_number": "12023187079",
                              "title": "Marketing",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:57:00.538Z",
                              "rateOfSend": 1
                            },
                            {
                              "id": 220,
                              "phone_number": "12023186840",
                              "title": "Support",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:45.497Z",
                              "rateOfSend": 1
                            },
                            {
                              "id": 218,
                              "phone_number": "12023186607",
                              "title": "Paul Kidd",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:09.958Z",
                              "rateOfSend": 2
                            }
                          ],
                          "password_changed_at": "2021-01-20T06:41:01.204Z",
                          "passwords": [],
                          "isPasswordExpired": false
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of User.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '515ce094-6635-4208-ac18-65ba5013366a']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `Email of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'hbergman@advancedvoipsolutions.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['first_name', `Description`, `First Name of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hayden']
                      },
                      {
                        rowSpan: 3,
                        columns: ['last_name', `Description`, `Last Name of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Bergman']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `User Title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Account Executive']
                      },
                      {
                        rowSpan: 3,
                        columns: ['default_phone_id', `Description`, `Default Phone Number Id associated with the user.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 217]
                      },
                      {
                        rowSpan: 3,
                        columns: ['show_censor_contact', `Description`, `Censor Contact is enabled or disabled for the User.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true/false']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phones', `Description`, `List of Phones Details assigned to the User.`]
                      },
                      {
                        columns: ['Type', 'Array']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": 220,
                              "phone_number": "12023186840",
                              "title": "Support",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:45.497Z",
                              "rateOfSend": 1
                          },
                          {
                              "id": 217,
                              "phone_number": "12023187094",
                              "title": "Hayden Bergman",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:55:53.157Z",
                              "rateOfSend": 1
                          }
                      ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['isPasswordExpired', `Description`, `It shows Password is Expired or not.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true/false']
                      },
                    ]
                  }
                ]
              }
            }
          ]
        },
        "User Details By ID": {
          title: 'Users Details By ID',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching User Details by ID."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/messageview/user/{id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `User ID is required for fetching Users Details.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '515ce094-6635-4208-ac18-65ba5013366a']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/messageview/users/515ce094-6635-4208-ac18-65ba5013366a`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "id": "515ce094-6635-4208-ac18-65ba5013366a",
                        "email": "hbergman@advancedvoipsolutions.com",
                        "must_change_password": false,
                        "first_name": "Hayden",
                        "last_name": "Bergman",
                        "title": "Account Executive",
                        "default_phone_id": 217,
                        "created": "2019-11-11T13:28:51.551Z",
                        "show_censor_contact": true,
                        "phones": [
                          {
                            "id": 217,
                            "phone_number": "12023187094",
                            "title": "Hayden Bergman",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-11-11T15:55:53.157Z",
                            "rateOfSend": 1
                          },
                          {
                            "id": 220,
                            "phone_number": "12023186840",
                            "title": "Support",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-11-11T15:56:45.497Z",
                            "rateOfSend": 1
                          }
                        ],
                        "password_changed_at": "2021-01-20T07:02:38.000Z",
                        "passwords": [],
                        "isPasswordExpired": false
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of User.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '515ce094-6635-4208-ac18-65ba5013366a']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `Email of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'hbergman@advancedvoipsolutions.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['first_name', `Description`, `First Name of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hayden']
                      },
                      {
                        rowSpan: 3,
                        columns: ['last_name', `Description`, `Last Name of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Bergman']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Title of User.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Account Executive']
                      },
                      {
                        rowSpan: 3,
                        columns: ['default_phone_id', `Description`, `Default Phone Number Id associated with the user.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 217]
                      },
                      {
                        rowSpan: 3,
                        columns: ['show_censor_contact', `Description`, `Censor Contact is enabled or disabled for the User.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true/false']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phones', `Description`, `List of Phones Details assigned to the User.`]
                      },
                      {
                        columns: ['Type', 'Array']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": 220,
                              "phone_number": "12023186840",
                              "title": "Support",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:56:45.497Z",
                              "rateOfSend": 1
                          },
                          {
                              "id": 217,
                              "phone_number": "12023187094",
                              "title": "Hayden Bergman",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-11-11T15:55:53.157Z",
                              "rateOfSend": 1
                          }
                      ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['isPasswordExpired', `Description`, `It shows Password is Expired or not.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true/false']
                      },
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Number List": {
          title: 'Number List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Number List associated with the Customer."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/phones/company/{customer_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customer_id', `Description`, `Customer ID is required for fetching Numbers List.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '9ca8cbca-08e5-4547-a950-fe4842f77fe8']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/phones/company/9ca8cbca-08e5-4547-a950-fe4842f77fe8`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "status": "ok",
                        "status_code": 200,
                        "data": [
                          {
                            "id": 217,
                            "phone_number": "12023187094",
                            "title": "Hayden Bergman",
                            "timezone": "America/New_York",
                            "created_at": "2019-11-11T15:55:53.157Z",
                            "rateOfSend": 1,
                            "users": [
                              {
                                "id": "515ce094-6635-4208-ac18-65ba5013366a",
                                "email": "hbergman@advancedvoipsolutions.com",
                                "first_name": "Hayden",
                                "last_name": "Bergman",
                                "password_changed_at": "2021-01-20T07:12:54.150Z",
                                "passwords": [],
                                "isPasswordExpired": false
                              }
                            ]
                          },
                          {
                            "id": 219,
                            "phone_number": "12023186839",
                            "title": "Nate Lee",
                            "timezone": "America/New_York",
                            "created_at": "2019-11-11T15:56:28.276Z",
                            "rateOfSend": 1,
                            "users": [
                              {
                                "id": "24ed90d7-94bc-4c45-a4af-5e42cf7fbf39",
                                "email": "nitesh.test12@gmail.com",
                                "first_name": "Nitesh12",
                                "last_name": "Test",
                                "password_changed_at": "2021-01-20T07:12:54.151Z",
                                "passwords": [],
                                "isPasswordExpired": false
                              },
                              {
                                "id": "e96ab4f6-586c-4499-bf60-d29513e8763c",
                                "email": "nlee@advancedvoipsolutions.com",
                                "first_name": "Nate",
                                "last_name": "Lee",
                                "password_changed_at": "2021-01-20T07:12:54.151Z",
                                "passwords": [],
                                "isPasswordExpired": false
                              }
                            ]
                          },
                          {
                            "id": 221,
                            "phone_number": "12023187079",
                            "title": "Marketing",
                            "timezone": "America/New_York",
                            "created_at": "2019-11-11T15:57:00.538Z",
                            "rateOfSend": 1,
                            "users": [
                              {
                                "id": "4e5b5038-e189-4426-8dcb-f7d59aefdb57",
                                "email": "pkidd@advancedvoipsolutions.com",
                                "first_name": "Paul",
                                "last_name": "Kidd",
                                "password_changed_at": "2021-01-20T07:12:54.151Z",
                                "passwords": [],
                                "isPasswordExpired": false
                              },
                              {
                                "id": "e96ab4f6-586c-4499-bf60-d29513e8763c",
                                "email": "nlee@advancedvoipsolutions.com",
                                "first_name": "Nate",
                                "last_name": "Lee",
                                "password_changed_at": "2021-01-20T07:12:54.151Z",
                                "passwords": [],
                                "isPasswordExpired": false
                              }
                            ]
                          }
                        ]
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '217']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '12023187094']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Phone Title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hayden Bergman']
                      },
                      {
                        rowSpan: 3,
                        columns: ['timezone', `Description`, `Phone Timezone.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'America/New_York']
                      },
                      {
                        rowSpan: 3,
                        columns: ['rateOfSend', `Description`, `Number of SMS/MMS Sends in 1 Second.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      },
                      {
                        rowSpan: 3,
                        columns: ['users', `Description`, `List of Users Details assigned to the Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Array']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": "515ce094-6635-4208-ac18-65ba5013366a",
                              "email": "hbergman@advancedvoipsolutions.com",
                              "first_name": "Hayden",
                              "last_name": "Bergman",
                              "password_changed_at": "2021-01-20T07:12:54.150Z",
                              "passwords": [],
                              "isPasswordExpired": false
                          }
                      ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Number Details By ID": {
          title: 'Number Details By ID',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Number Details by ID."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/phone/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Phone Details.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 217]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/phone/217`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "status": "ok",
                        "status_code": 200,
                        "data": {
                          "id": 217,
                          "phone_number": "12023187094",
                          "title": "Hayden Bergman",
                          "timezone": "America/New_York",
                          "created_at": "2019-11-11T15:55:53.157Z",
                          "rateOfSend": 1,
                          "users": [
                            {
                              "id": "515ce094-6635-4208-ac18-65ba5013366a",
                              "email": "hbergman@advancedvoipsolutions.com",
                              "first_name": "Hayden",
                              "last_name": "Bergman",
                              "password_changed_at": "2021-01-20T07:26:04.280Z",
                              "passwords": [],
                              "isPasswordExpired": false
                            }
                          ]
                        }
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '217']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '12023187094']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Phone Title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hayden Bergman']
                      },
                      {
                        rowSpan: 3,
                        columns: ['timezone', `Description`, `Phone Timezone.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'America/New_York']
                      },
                      {
                        rowSpan: 3,
                        columns: ['rateOfSend', `Description`, `Number of SMS/MMS Sends in 1 Second.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      },
                      {
                        rowSpan: 3,
                        columns: ['users', `Description`, `List of Users Details assigned to the Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Array']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": "515ce094-6635-4208-ac18-65ba5013366a",
                              "email": "hbergman@advancedvoipsolutions.com",
                              "first_name": "Hayden",
                              "last_name": "Bergman",
                              "password_changed_at": "2021-01-20T07:12:54.150Z",
                              "passwords": [],
                              "isPasswordExpired": false
                          }
                      ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Search New Number": {
          title: 'Search New Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for searching the available numbers based on multiple search criteria. The search criteria - country and didType are required."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/phones/{area_code}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['area_code', `Description`, `To search number for a specific area code, max of 3 digit and put 'undefined' if no area code.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '222']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/phones/222`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`country`, `Description`, `The country, from which, number is been searched. We support two Country Code for now ["US","CA"].`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'US']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`didType`, `Description`, `Type of numbers you are seaching for. We support two Didtype for now ["Mobile & Landline","Toll Free"].`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Mobile & Landline']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "didType": "Mobile & Landline",
                      "country": "US"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "lastIndex": 1733428,
                      "tns": [
                        {
                          "did": [
                            9857451829
                          ],
                          "country": "United States",
                          "state": "Louisiana",
                          "lata": "490",
                          "npa": "985",
                          "nxx": "745",
                          "rateCenter": "MORGANCITY",
                          "didType": "Mobile",
                          "quantity": 1,
                          "snStart": "1829",
                          "snEnd": "1829"
                        },
                        {
                          "did": [
                            9859001998
                          ],
                          "country": "United States",
                          "state": "Louisiana",
                          "lata": "490",
                          "npa": "985",
                          "nxx": "900",
                          "rateCenter": "COVINGTON",
                          "didType": "Mobile",
                          "quantity": 1,
                          "snStart": "1998",
                          "snEnd": "1998"
                        }
                      ],
                      "didGroupId": 0,
                      "status": 200
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['lastIndex', `Description`, ``]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '1733428']
                      },
                      {
                        rowSpan: 3,
                        columns: ['did', `Description`, `	List of numbers.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '[9857451829]']
                      },
                      {
                        rowSpan: 3,
                        columns: ['country', `Description`, `Country Where the numbers are located.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'United States']
                      },
                      {
                        rowSpan: 3,
                        columns: ['didType', `Description`, `Type of numbers can be Mobile, toll-free, land-line.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Mobile']
                      },
                      {
                        rowSpan: 3,
                        columns: ['lata', `Description`, `For USA Numbers the Local Access and Transport Area.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '490']
                      },
                      {
                        rowSpan: 3,
                        columns: ['npa', `Description`, `The Area code for a number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `985`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['nxx', `Description`, `Exchange for a number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `745`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['rateCenter', `Description`, `Localized area for a number smaller then City or LATA.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `MORGANCITY`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['state', `Description`, `State, Province or similar geographic identifier.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Louisiana`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        // "Search CPaaS Inventory Number": {
        //   title: 'Search CPaaS Inventory Number',
        //   parentTags: [
        //     {
        //       P: {
        //         detail: "This is a REST API for searching CPaaS Inventory Numbers."
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: "Request" },
        //           {
        //             key: TABLE,
        //             rows: [
        //               {
        //                 columns: ['Endpoint:', `${API_URL}/cpaas/numbers`]
        //               },
        //               {
        //                 columns: ['Method:', 'POST']
        //               },
        //               {
        //                 columns: ['Headers:', 'Authorization: Bearer <access_token>']
        //               }
        //             ]
        //           }
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: 'Request Body For Complete Search' },
        //           { key: H4, detail: 'Example:' },
        //           {
        //             key: JSON, detail: {
        //               "serachNumber": "",
        //               "customerId": "42",
        //               "excludedNumbers": []
        //             }
        //           },
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: 'Request Body For Partial Search' },
        //           { key: H4, detail: 'Example:' },
        //           {
        //             key: JSON, detail: {
        //               "serachNumber": "800",
        //               "customerId": "42",
        //               "excludedNumbers": ["2064717903"]
        //             }
        //           },
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: "POST Request Body Data" },
        //           {
        //             key: TABLE,
        //             rows: [
        //               {
        //                 rowSpan: 4,
        //                 columns: [`serachNumber`, `Description`, `Search Number is used for Partial search or specific search for the number.`]
        //               },
        //               {
        //                 columns: ['Type', "String"]
        //               },
        //               {
        //                 columns: ['Example', '800']
        //               },
        //               {
        //                 columns: ['Required', 'Yes']
        //               },
        //               {
        //                 rowSpan: 4,
        //                 columns: [`customerId`, `Description`, `Put CPaaS Customer/Account ID for which you are looking CPaaS Inventory.`]
        //               },
        //               {
        //                 columns: ['Type', 'Integer']
        //               },
        //               {
        //                 columns: ['Example', '42']
        //               },
        //               {
        //                 columns: ['Required', 'Yes']
        //               },
        //               {
        //                 rowSpan: 4,
        //                 columns: [`excludedNumbers`, `Description`, `In Excluded Numbers put those number which you need to remove number from the search. Put empty if you do not wants to remove any number from the search.`]
        //               },
        //               {
        //                 columns: ['Type', 'Array of String']
        //               },
        //               {
        //                 columns: ['Example', `["2064717903"]`]
        //               },
        //               {
        //                 columns: ['Required', 'Yes']
        //               }
        //             ]
        //           }
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: 'Response' },
        //           { key: H4, detail: 'Example:' },
        //           {
        //             key: JSON, detail: [
        //               {
        //                 "didNumber": 2064717903,
        //                 "customer": "acc_test",
        //                 "customerId": 42,
        //                 "accountId": 68,
        //                 "trunkId": "875",
        //                 "account": "acc_first",
        //                 "smsCapable": true,
        //                 "smsEnabled": false,
        //                 "mmsCapable": false,
        //                 "mmsEnabled": false,
        //                 "e911Capable": false,
        //                 "e911Enabled": false,
        //                 "portinEnabled": false,
        //                 "portinCapable": false,
        //                 "editableSupplier": false,
        //                 "a2p": false
        //               },
        //               {
        //                 "didNumber": 2064717072,
        //                 "customer": "acc_test",
        //                 "customerId": 42,
        //                 "accountId": 43,
        //                 "trunkId": "167",
        //                 "account": "acc_test_acc",
        //                 "smsCapable": true,
        //                 "smsEnabled": false,
        //                 "mmsCapable": false,
        //                 "mmsEnabled": false,
        //                 "e911Capable": false,
        //                 "e911Enabled": false,
        //                 "cnam": "",
        //                 "portinEnabled": false,
        //                 "portinCapable": false,
        //                 "domainName": "acme.st.messagepro.io",
        //                 "domainId": 5,
        //                 "editableSupplier": false,
        //                 "a2p": false
        //               }
        //             ]
        //           },
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           {
        //             key: TABLE,
        //             rows: [
        //               {
        //                 rowSpan: 3,
        //                 columns: ['didNumber', `Description`, `Phone Number`]
        //               },
        //               {
        //                 columns: ['Type', 'String']
        //               },
        //               {
        //                 columns: ['Example', '2064717072']
        //               },
        //               {
        //                 rowSpan: 3,
        //                 columns: ['customer', `Description`, `CPaaS Customer Name.`]
        //               },
        //               {
        //                 columns: ['Type', 'String']
        //               },
        //               {
        //                 columns: ['Example', 'acc_test']
        //               },
        //               {
        //                 rowSpan: 3,
        //                 columns: ['customerId', `Description`, `CPaaS Customer Id.`]
        //               },
        //               {
        //                 columns: ['Type', 'Integer']
        //               },
        //               {
        //                 columns: ['Example', 42]
        //               },
        //               {
        //                 rowSpan: 3,
        //                 columns: ['account', `Description`, `CPaaS Account Name.`]
        //               },
        //               {
        //                 columns: ['Type', 'String']
        //               },
        //               {
        //                 columns: ['Example', 'acc_test_acc']
        //               },
        //               {
        //                 rowSpan: 3,
        //                 columns: ['accountId', `Description`, `CPaaS Account Id.`]
        //               },
        //               {
        //                 columns: ['Type', 'Integer']
        //               },
        //               {
        //                 columns: ['Example', 43]
        //               }
        //             ]
        //           }
        //         ]
        //       }
        //     }
        //   ]
        // }
        "Customer Report": {
          title: 'Customer Report',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Customer Report as per request.",
                childTags: [
                  { key: P },
                  // { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/customer/reports`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: ['customer_id', `Description`, `Customer ID is required for fetch report data.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'c306f831-53a3-41ac-aa66-5df94cf6fd47']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['from', `Description`, `Select a From date from which you want to search report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2017-05-04']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['phone_number', `Description`, `In case if a phone number is selected for a particular customer, otherwise data is for all the phone numbers of the customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '17323078430']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: ['to', `Description`, `Select a  To date upto which you want to search a report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2022-06-20']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      // {
                      //   rowSpan: 3,
                      //   columns: ['phone_id', `Description`, `Phone ID is required for fetching Report.`]
                      // },
                      // {
                      //   columns: ['Type', 'Integer']
                      // },
                      // {
                      //   columns: ['Example', 251]
                      // }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body (for all numbers of the customer)' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id":"c306f831-53a3-41ac-aa66-5df94cf6fd47",
                      "from":"2017-05-04",
                      "to":"2022-06-20"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body (for selected number of the customer)' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id":"c306f831-53a3-41ac-aa66-5df94cf6fd47",
                      "from":"2017-05-04",
                      "phone_number": "17323078432",
                      "to":"2022-06-20"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "data": {
                        "diagramData": {"status":"ok","status_code":200,"reportData":{"before":"2017-05-04T00:00:00.000Z","after":"2022-06-20T00:00:00.000Z","startDate":"2017-05-01T00:00:00.000Z","endDate":"2022-06-30T00:00:00.000Z","reportType":"Month","dateFormat":"MMM(YYYY)","customer_ids_string":"'c306f831-53a3-41ac-aa66-5df94cf6fd47'","userPhoneReportData":[{"created_date":"2019-11","phone_count":"1","user_count":"0"},{"created_date":"2019-10","phone_count":"3","user_count":"12"},{"created_date":"2019-09","phone_count":"4","user_count":"3"}],"segmentReportData":[],"messageReportData":[{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2020-01-16T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2020-01-07T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-12-23T18:30:00.000Z"},{"inbound_count":"0","outbound_count":"1","sent_at_truncated_to_day":"2019-12-18T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-12-17T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-12-16T18:30:00.000Z"},{"inbound_count":"2","outbound_count":"0","sent_at_truncated_to_day":"2019-12-12T18:30:00.000Z"},{"inbound_count":"2","outbound_count":"0","sent_at_truncated_to_day":"2019-12-10T18:30:00.000Z"},{"inbound_count":"3","outbound_count":"0","sent_at_truncated_to_day":"2019-12-09T18:30:00.000Z"},{"inbound_count":"2","outbound_count":"0","sent_at_truncated_to_day":"2019-12-03T18:30:00.000Z"},{"inbound_count":"2","outbound_count":"0","sent_at_truncated_to_day":"2019-12-02T18:30:00.000Z"},{"inbound_count":"2","outbound_count":"0","sent_at_truncated_to_day":"2019-11-28T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-11-24T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-11-19T18:30:00.000Z"},{"inbound_count":"0","outbound_count":"7","sent_at_truncated_to_day":"2019-11-13T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-11-07T18:30:00.000Z"},{"inbound_count":"5","outbound_count":"4","sent_at_truncated_to_day":"2019-11-05T18:30:00.000Z"},{"inbound_count":"3","outbound_count":"8","sent_at_truncated_to_day":"2019-11-04T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-11-03T18:30:00.000Z"},{"inbound_count":"7","outbound_count":"28","sent_at_truncated_to_day":"2019-10-31T18:30:00.000Z"},{"inbound_count":"3","outbound_count":"5","sent_at_truncated_to_day":"2019-10-24T18:30:00.000Z"},{"inbound_count":"1","outbound_count":"0","sent_at_truncated_to_day":"2019-09-19T18:30:00.000Z"},{"inbound_count":"5","outbound_count":"6","sent_at_truncated_to_day":"2019-09-18T18:30:00.000Z"},{"inbound_count":"3","outbound_count":"3","sent_at_truncated_to_day":"2019-09-16T18:30:00.000Z"},{"inbound_count":"4","outbound_count":"8","sent_at_truncated_to_day":"2019-09-12T18:30:00.000Z"},{"inbound_count":"2","outbound_count":"9","sent_at_truncated_to_day":"2019-09-11T18:30:00.000Z"}],"blastReportData":[],"phoneNumbers":["17323078432","17323078430","17323078431","17329521024","17326626943","14702205170","17322253099","13012152861"],"diagramData":{"user_count":15,"phone_count":8,"sms_segment":0,"mms_segment":0,"inbound_count":55,"outbound_count":79,"delivered_count":0,"rejected_count":0,"compliance_count":0,"blast_contacts_count":0}}}
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Download Customer Report": {
          title: 'Download Customer Report',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Download Report as per request.",
                // childTags: [
                //   { key: P },
                //   { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                // ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/csv-data/customer/reports`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: ['customer_id', `Description`, `Customer ID is required for fetch csv data.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'c306f831-53a3-41ac-aa66-5df94cf6fd47']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['report_type', `Description`, `Report Type is required. Valid Report are [MESSAGE_REPORT, BLAST_REPORT]`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'MESSAGE_REPORT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['from', `Description`, `Select a From date from which you want to search report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2017-05-04']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['phone_number', `Description`, `In case if a phone number is selected for a particular customer, otherwise data is for all the phone numbers of the customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '17323078430']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: ['to', `Description`, `Select a  To date upto which you want to search a report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2022-06-20']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body (for all numbers of the customer)' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id":"c306f831-53a3-41ac-aa66-5df94cf6fd47",
                      "from":"2017-05-04",
                      "to":"2022-06-20",
                      "report_type":"MESSAGE_REPORT"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body (for selected number of the customer)' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id":"c306f831-53a3-41ac-aa66-5df94cf6fd47",
                      "from":"2017-05-04",
                      "phone_number": "17323078432",
                      "to":"2022-06-20",
                      "report_type":"MESSAGE_REPORT"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": [
                        {
                          "from": "15402954611",
                          "to": "17322253022",
                          "text_content": "Glenn\n",
                          "name": "Test ",
                          "type": "INBOUND",
                          "status": "SUCCESS",
                          "sent_at_truncated_to_day": "2020-01-17T17:29:12.197Z"
                        },
                        {
                          "from": "17322253011",
                          "to": "17327134222",
                          "text_content": "test",
                          "name": "Nick Marrone",
                          "type": "OUTBOUND",
                          "status": "SCCCESS",
                          "sent_at_truncated_to_day": "2019-11-05T14:33:36.830Z"
                        }
                      ]
                    }
                  },
                ]
              }
            }
          ]
        },
      }
    },
    Count: {
      chlidLinks: {
        "Customer Count By Partner": {
          title: 'Customer Count By Partner',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Customers Count associated with the Partner."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`partner_id`, `Description`, `Partner ID is required for fetching Customers Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4eddecb9-0b9f-4a20-9901-16cc02e4f0ed']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'CUSTOMER_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'CUSTOMER_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'PARTNER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'PARTNER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "partner_id": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                      "count_type": "CUSTOMER_COUNT",
                      "search_type": "PARTNER",
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "customer_count": 4
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customer_count', `Description`, `Count of Customers associated with the Partner.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 4]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "User Count By Partner": {
          title: 'User Count By Partner',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching User Count associated with the Partner."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`partner_id`, `Description`, `Partner ID is required for fetching User Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4eddecb9-0b9f-4a20-9901-16cc02e4f0ed']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'USER_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'USER_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'PARTNER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'PARTNER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "partner_id": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                      "count_type": "USER_COUNT",
                      "search_type": "PARTNER"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "user_count": 39
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['user_count', `Description`, `Count of Users associated with the Partner.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 39]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "User Count By Customer": {
          title: 'User Count By Customer',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching User Count associated with the Customer."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`customer_id`, `Description`, `Customer ID is required for fetching User Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'b2d680eb-5e17-4ca6-acd7-7e06ad319da1']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'USER_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'USER_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'CUSTOMER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CUSTOMER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id": "b2d680eb-5e17-4ca6-acd7-7e06ad319da1",
                      "count_type": "USER_COUNT",
                      "search_type": "CUSTOMER"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "user_count": 39
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['user_count', `Description`, `Count of Users associated with the Customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 39]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Number Count By Partner": {
          title: 'Number Count By Partner',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Phone Number Count associated with the Partner."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`partner_id`, `Description`, `Partner ID is required for fetching Phone Number Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4eddecb9-0b9f-4a20-9901-16cc02e4f0ed']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'PHONE_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'PHONE_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'PARTNER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'PARTNER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "partner_id": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                      "count_type": "PHONE_COUNT",
                      "search_type": "PARTNER"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "phone_count": 57
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_count', `Description`, `Count of Phone Number associated with the Partner.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 39]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Number Count By Customer": {
          title: 'Number Count By Customer',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Phone Number Count associated with the Customer."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`customer_id`, `Description`, `Customer ID is required for fetching Phone Number Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'b2d680eb-5e17-4ca6-acd7-7e06ad319da1']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'PHONE_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'PHONE_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'CUSTOMER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CUSTOMER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id": "b2d680eb-5e17-4ca6-acd7-7e06ad319da1",
                      "count_type": "PHONE_COUNT",
                      "search_type": "CUSTOMER"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "phone_count": 2
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_count', `Description`, `Count of Phone Number associated with the Customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 39]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Message Count By Partner": {
          title: 'Message Count By Partner',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Message Count for the Partner."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`partner_id`, `Description`, `Partner ID is required for fetching Message Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4eddecb9-0b9f-4a20-9901-16cc02e4f0ed']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'MESSAGE_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'MESSAGE_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'PARTNER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'PARTNER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`start`, `Description`, `Start Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-01']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`end`, `Description`, `End Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-02']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "partner_id": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                      "count_type": "MESSAGE_COUNT",
                      "search_type": "PARTNER",
                      "start": "2021-02-01",
                      "end": "2021-02-02"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "message_count": 22311
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['message_count', `Description`, `Count of Message for the Partner.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 4]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Message Count By Customer": {
          title: 'Message Count By Customer',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Message Count for the Customer."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`customer_id`, `Description`, `Customer ID is required for fetching Message Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'b2d680eb-5e17-4ca6-acd7-7e06ad319da1']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'MESSAGE_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'MESSAGE_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'CUSTOMER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CUSTOMER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`start`, `Description`, `Start Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-01']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`end`, `Description`, `End Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-02']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id": "b2d680eb-5e17-4ca6-acd7-7e06ad319da1",
                      "count_type": "MESSAGE_COUNT",
                      "search_type": "CUSTOMER",
                      "start": "2021-02-01",
                      "end": "2021-02-27"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "message_count": 41
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['message_count', `Description`, `Count of Message for the Customer.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 39]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Message Count By User": {
          title: 'Message Count By User',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Message Count for the User."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`user_id`, `Description`, `User ID is required for fetching Message Count.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '6d3cc87e-6ffa-4414-8bcb-a4c40342aa71']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'MESSAGE_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'MESSAGE_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'CUSTOMER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'USER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`start`, `Description`, `Start Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-01']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`end`, `Description`, `End Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-02']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "user_id": "6d3cc87e-6ffa-4414-8bcb-a4c40342aa71",
                      "count_type": "MESSAGE_COUNT",
                      "search_type": "USER",
                      "start": "2021-02-01",
                      "end": "2021-02-27"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "message_count": 45
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['message_count', `Description`, `Count of Message for the User.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 39]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Message Count By Number": {
          title: 'Message Count By Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Message Count for the Phone Number."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/count`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`phone_number`, `Description`, `Phone Number is required for fetching Message Count.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '14045964668']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`count_type`, `Description`, `This is Fixed value Always needs to send 'MESSAGE_COUNT'.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'MESSAGE_COUNT']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_type`, `Description`, `This is Fixed value Always needs to send 'NUMBER'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'NUMBER']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`start`, `Description`, `Start Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-01']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`end`, `Description`, `End Date in YYYY-MM-DD format.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-02-02']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "phone_number": "14045964668",
                      "count_type": "MESSAGE_COUNT",
                      "search_type": "NUMBER",
                      "start": "2021-02-01",
                      "end": "2021-02-27"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "message_count": 2
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['message_count', `Description`, `Count of Message for the Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 2]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      }
    },
    Write: {
      chlidLinks: {
        "Create Customer": {
          title: 'Create Customer',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Customer. Required fields are Parent Id(Means Partner's Id), Customer Name, status(Accepted value are Active-1, Inactive-2), user_level is always 'customer' it's a fixed value, remaining fields are optional."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/users`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`name`, `Description`, `Customer Name.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Dummy Customer']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`status`, `Description`, `For Activate the customer status value is 1, for Deactivate the customer status value is 2.`]
                      },
                      {
                        columns: ['Type', "Integer"]
                      },
                      {
                        columns: ['Example', '1']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`user_level`, `Description`, `This is Fixed value Always needs to send 'customer'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'customer']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`parent`, `Description`, `parent means partner Id's for which you need to create a customer.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'debd116a-dde3-4541-9d89-83ed5734181b']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`eamil`, `Description`, `Customer emails which is used during login time.`]
                      },
                      {
                        columns: ['Type', 'eamil']
                      },
                      {
                        columns: ['Example', 'dummy.customer@gmail.com']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`contact`, `Description`, `Give the contact info.`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "admin_contact":"Dummy admin",
                          "admin_email":"dummy.admin@gmail.com",
                          "admin_phone":"8882918777",
                          "billing_contact":"Dummy Billing Contact",
                          "billing_email":"dummy.billing.contact@gmail.com",
                          "billing_phone":"8882918777",
                          "primary_contact":"Dummy Primary Contact ",
                          "primary_email":"dummy.primary.contact@gmail.com",
                          "primary_phone":"8287845279"
                          }`]
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "name": "Dummy Customer",
                      "status": 1,
                      "user_level": "customer",
                      "parent": "debd116a-dde3-4541-9d89-83ed5734181b",
                      "email": "dummy.customer@gmail.com",
                      "contact": {
                        "admin_contact": "Dummy admin",
                        "admin_email": "dummy.admin@gmail.com",
                        "admin_phone": "8882918777",
                        "billing_contact": "Dummy Billing Contact",
                        "billing_email": "dummy.billing.contact@gmail.com",
                        "billing_phone": "8882918777",
                        "primary_contact": "Dummy Primary Contact ",
                        "primary_email": "dummy.primary.contact@gmail.com",
                        "primary_phone": "8287845279"
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 201,
                      "data": {
                        "name": "Dummy Customer",
                        "email": "dummy.customer@gmail.com",
                        "status": 1,
                        "user_level": "customer",
                        "parent": "debd116a-dde3-4541-9d89-83ed5734181b",
                        "contact": {
                          "admin_contact": "Dummy admin",
                          "admin_email": "dummy.admin@gmail.com",
                          "admin_phone": "8882918777",
                          "billing_contact": "Dummy Billing Contact",
                          "billing_email": "dummy.billing.contact@gmail.com",
                          "billing_phone": "8882918777",
                          "primary_contact": "Dummy Primary Contact ",
                          "primary_email": "dummy.primary.contact@gmail.com",
                          "primary_phone": "8287845279",
                          "id": 318
                        },
                        "password": "sha1$67c30375$1$20cf6e1b61fbf86e84d6761fc4b98d89360b717c",
                        "must_change_password": true,
                        "password_changed_at": "2021-01-21T07:48:51.861Z",
                        "password_reset_expiries": null,
                        "password_reset_token": null,
                        "passwords": null,
                        "id": "303d68bc-2f15-4b18-b666-9197011a2f72",
                        "first_name": "",
                        "last_name": "",
                        "title": "",
                        "send_email_invite": true,
                        "is_deleted": false,
                        "created": "2021-01-21T07:48:51.861Z",
                        "recent_activity": "2021-01-21T07:48:51.861Z"
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Customer Name.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Dummy Customer']
                      },
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the Customer.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `Customer email.`]
                      },
                      {
                        columns: ['Type', 'string']
                      },
                      {
                        columns: ['Example', 'dummy.customer@gmail.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['send_email_invite', `Description`, `It send a welcome email to the Customer.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        rowSpan: 3,
                        columns: ['parent', `Description`, `Parent means(Partner Id) under which customer created.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      },
                      {
                        rowSpan: 3,
                        columns: ['contact', `Description`, `It contain contact info.`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "admin_contact": "Dummy admin",
                          "admin_email": "dummy.admin@gmail.com",
                          "admin_phone": "8882918777",
                          "billing_contact": "Dummy Billing Contact",
                          "billing_email": "dummy.billing.contact@gmail.com",
                          "billing_phone": "8882918777",
                          "primary_contact": "Dummy Primary Contact ",
                          "primary_email": "dummy.primary.contact@gmail.com",
                          "primary_phone": "8287845279",
                          "id": 318
                        }`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Update Customer": {
          title: 'Update Customer',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Customer. Required fields are Customer Name, status(Accepted value are Active-1, Inactive-2), user_level is always 'customer' it's a fixed value, remaining fields are optional."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/users/{id}`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Customer ID is required for Update Customer Details.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/users/303d68bc-2f15-4b18-b666-9197011a2f72`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`name`, `Description`, `Customer Name.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Dummy Customer']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`status`, `Description`, `For Activate the customer status value is 1, for Deactivate the customer status value is 2.`]
                      },
                      {
                        columns: ['Type', "Integer"]
                      },
                      {
                        columns: ['Example', '1']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`user_level`, `Description`, `This is Fixed value Always needs to send 'customer'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'customer']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`contact`, `Description`, `Give the contact info.`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "admin_contact":"Dummy admin",
                          "admin_email":"dummy.admin@gmail.com",
                          "admin_phone":"8882918777",
                          "billing_contact":"Dummy Billing Contact",
                          "billing_email":"dummy.billing.contact@gmail.com",
                          "billing_phone":"8882918777",
                          "primary_contact":"Dummy Primary Contact ",
                          "primary_email":"dummy.primary.contact@gmail.com",
                          "primary_phone":"8287845279"
                          }`]
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "name": "Dummy Customer",
                      "status": 1,
                      "user_level": "customer",
                      "contact": {
                        "admin_contact": "Dummy admin",
                        "admin_email": "dummy.admin@gmail.com",
                        "admin_phone": "8882918777",
                        "billing_contact": "Dummy Billing Contact",
                        "billing_email": "dummy.billing.contact@gmail.com",
                        "billing_phone": "8882918777",
                        "primary_contact": "Dummy Primary Contact ",
                        "primary_email": "dummy.primary.contact@gmail.com",
                        "primary_phone": "8287845279"
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 201,
                      "data": {
                        "id": "303d68bc-2f15-4b18-b666-9197011a2f72",
                        "first_name": "",
                        "last_name": "",
                        "title": "",
                        "name": "Dummy Customer",
                        "email": "dummy.customer@gmail.com",
                        "status": 2,
                        "must_change_password": true,
                        "password_reset_token": null,
                        "user_level": "customer",
                        "send_email_invite": true,
                        "is_deleted": false,
                        "created": "2021-01-21T07:48:51.861Z",
                        "recent_activity": "2021-01-21T07:48:51.861Z",
                        "parent": "debd116a-dde3-4541-9d89-83ed5734181b",
                        "roles": [],
                        "reseller": null,
                        "customer": null,
                        "contact": {
                          "admin_contact": "Dummy admin",
                          "admin_email": "dummy.admin@gmail.com",
                          "admin_phone": "8882918777",
                          "billing_contact": "Dummy Billing Contact",
                          "billing_email": "dummy.billing.contact@gmail.com",
                          "billing_phone": "8882918777",
                          "primary_contact": "Dummy Primary Contact ",
                          "primary_email": "dummy.primary.contact@gmail.com",
                          "primary_phone": "8287845279",
                          "id": 324
                        },
                        "agreement": null,
                        "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI5OWI3YzNlZC02YTNjLTQxYTctYjdmMS1kNThjZmVjYmZiNjciLCJyZW1lbWJlck1lIjp0cnVlLCJpYXQiOjE2MTA2ODUwODYsImV4cCI6MTYxMzI3NzA4Nn0.zgkbDL4tvCn0N1tLWgO_LukQ7aq7aR8IiAnkpUkiW2Q"
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Customer Name.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Dummy Customer']
                      },
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the Customer.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `Customer email.`]
                      },
                      {
                        columns: ['Type', 'string']
                      },
                      {
                        columns: ['Example', 'dummy.customer@gmail.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['parent', `Description`, `Parent means(Partner Id) under which customer created.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      },
                      {
                        rowSpan: 3,
                        columns: ['contact', `Description`, `It contain contact info.`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "admin_contact": "Dummy admin",
                          "admin_email": "dummy.admin@gmail.com",
                          "admin_phone": "8882918777",
                          "billing_contact": "Dummy Billing Contact",
                          "billing_email": "dummy.billing.contact@gmail.com",
                          "billing_phone": "8882918777",
                          "primary_contact": "Dummy Primary Contact ",
                          "primary_email": "dummy.primary.contact@gmail.com",
                          "primary_phone": "8287845279",
                          "id": 318
                        }`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Create User Using New Number": {
          title: 'Create User Using New Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create User Using New Number. Required fields are email, first name, last name, phone details, numberType is always 'NUMBER_GET_NEW' it's a fixed value, remaining fields are optional.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.COMMANDCENTER_API_URL}#Read#6`, detail: 'Click here to Get New Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/messageview/users/{customer_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customer_id', `Description`, `Customer Id for which you need to create a user.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/messageview/users/303d68bc-2f15-4b18-b666-9197011a2f72`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `User Email.`]
                      },
                      {
                        columns: ['Type', 'Email']
                      },
                      {
                        columns: ['Example', 'dummy.user@gmail.com']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`first_name`, `Description`, `First Name of the user.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'Dummy']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`last_name`, `Description`, `Last Name of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'User']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Dummy title']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`show_censor_contact`, `Description`, `Enable or Disable censor contact for the user.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 6,
                        columns: [`phone`, `Description`, `Put a valid number details please use above link to GET NEW NUMBER.`]
                      },
                      {
                        columns: ['owner', `Its a Customer Id for which need to assign a number, Customer Id must be same as ID in url.`]
                      },
                      {
                        columns: ['timezone', `Put any valid timezone for the numbers some of valid timezones are [America/New_York,"America/Los_Angeles","America/Chicago"].`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "phone_number": "19857451828",
                          "timezone": "America/New_York",
                          "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                        }`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`numberType`, `Description`, `This is fixed value need to send 'NUMBER_GET_NEW'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `NUMBER_GET_NEW`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "email": "dummy.user@gmail.com",
                      "first_name": "Dummy",
                      "last_name": "User",
                      "title": "Dummy title",
                      "show_censor_contact": true,
                      "phone": {
                        "phone_number": "19857451828",
                        "timezone": "America/New_York",
                        "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                      },
                      "username": "Nitesh",
                      "numberType": "NUMBER_GET_NEW"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "username": "Nitesh",
                        "email": "dummy.user@gmail.com",
                        "password": "sha1$1a755ab7$1$863778ddd15793a0b49a72479d81565c96a1b747",
                        "password_reset_expiries": "2021-01-21T11:38:07.433Z",
                        "send_email_invite": true,
                        "first_name": "Dummy",
                        "last_name": "User",
                        "title": "Dummy title",
                        "auto_status": 0,
                        "custom_status": 0,
                        "registration_status": 1,
                        "must_change_password": true,
                        "password_changed_at": "2021-01-21T11:38:07.838Z",
                        "timezone": "",
                        "reports_to": "",
                        "status": 1,
                        "show_censor_contact": true,
                        "company": {
                          "id": 164,
                          "name": "Dummy Customer",
                          "subdomain": "DummyCustomer",
                          "status": 1,
                          "created_at": "2021-01-21T07:48:51.947Z",
                          "active_at": "2021-01-21T07:48:51.947Z",
                          "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                          "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                          "disabled": false
                        },
                        "phones": [
                          {
                            "phone_number": "19857451828",
                            "timezone": "America/New_York",
                            "title": "Dummy User",
                            "company": {
                              "id": 164,
                              "name": "Dummy Customer",
                              "subdomain": "DummyCustomer",
                              "status": 1,
                              "created_at": "2021-01-21T07:48:51.947Z",
                              "active_at": "2021-01-21T07:48:51.947Z",
                              "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                              "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                              "disabled": false
                            },
                            "id": 601,
                            "is_deleted": false,
                            "created_at": "2021-01-20T22:08:07.822Z",
                            "rateOfSend": 1
                          }
                        ],
                        "default_phone_id": 601,
                        "password_reset_token": null,
                        "passwords": null,
                        "id": "8baff0d8-ab62-448e-b50c-66e8632c42aa",
                        "display_as": "",
                        "notes": "",
                        "created": "2021-01-21T08:26:15.921Z"
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the User.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '8baff0d8-ab62-448e-b50c-66e8632c42aa']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `User email.`]
                      },
                      {
                        columns: ['Type', 'string']
                      },
                      {
                        columns: ['Example', 'dummy.user@gmail.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['send_email_invite', `Description`, `It send a welcome email to the Customer.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phones', `Description`, `It contain  phone info.`]
                      },
                      {
                        columns: ['Type', 'Array of object']
                      },
                      {
                        columns: ['Example', `[
                          {
                            "phone_number": "19857451828",
                            "timezone": "America/New_York",
                            "title": "Dummy User",
                            "company": {
                              "id": 164,
                              "name": "Dummy Customer",
                              "subdomain": "DummyCustomer",
                              "status": 1,
                              "created_at": "2021-01-21T07:48:51.947Z",
                              "active_at": "2021-01-21T07:48:51.947Z",
                              "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                              "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                              "disabled": false
                            },
                            "id": 601,
                            "is_deleted": false,
                            "created_at": "2021-01-20T22:08:07.822Z",
                            "rateOfSend": 1
                          }
                        ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Create User Using Busisness Number": {
          title: 'Create User Using Busisness Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create User Using Busisness Number. Required fields are email, first name, last name, phone details, numberType is always 'NUMBER_USE_BUSINESS' it's a fixed value, remaining fields are optional."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/messageview/users/{customer_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customer_id', `Description`, `Customer Id for which you need to create a user.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/messageview/users/303d68bc-2f15-4b18-b666-9197011a2f72`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `User Email.`]
                      },
                      {
                        columns: ['Type', 'Email']
                      },
                      {
                        columns: ['Example', 'test.busisness@gmail.com']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`first_name`, `Description`, `First Name of the user.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'Harry']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`last_name`, `Description`, `Last Name of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Ryder']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Dummy title']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`show_censor_contact`, `Description`, `Enable or Disable censor contact for the user.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 6,
                        columns: [`phone`, `Description`, `Put a valid number details.`]
                      },
                      {
                        columns: ['owner', `Its a Customer Id for which need to assign a number, Customer Id must be same as ID in url.`]
                      },
                      {
                        columns: ['timezone', `Put any valid timezone for the numbers some of valid timezones are [America/New_York,"America/Los_Angeles","America/Chicago"].`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "phone_number": "16789408223",
                          "timezone": "America/New_York",
                          "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                        }`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`numberType`, `Description`, `This is fixed value need to send 'NUMBER_USE_BUSINESS'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `NUMBER_USE_BUSINESS`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "email": "test.busisness@gmail.com",
                      "first_name": "Harry",
                      "last_name": "Ryder",
                      "title": "title",
                      "show_censor_contact": true,
                      "phone": {
                        "phone_number": "16789408223",
                        "timezone": "America/New_York",
                        "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                      },
                      "username": "Harry",
                      "numberType": "NUMBER_USE_BUSINESS"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "username": "Harry",
                        "email": "test.busisness@gmail.com",
                        "password": "sha1$75d721ef$1$7152d9b57332626d443f7e49a205deef6a3ffcbf",
                        "password_reset_expiries": "2021-01-21T14:28:09.606Z",
                        "send_email_invite": true,
                        "first_name": "Harry",
                        "last_name": "Ryder",
                        "title": "title",
                        "auto_status": 0,
                        "custom_status": 0,
                        "registration_status": 1,
                        "must_change_password": true,
                        "password_changed_at": "2021-01-21T14:28:09.624Z",
                        "timezone": "",
                        "reports_to": "",
                        "status": 1,
                        "show_censor_contact": true,
                        "company": {
                          "id": 57,
                          "name": "AVS Internal",
                          "subdomain": "AVSInternal",
                          "status": 1,
                          "created_at": "2019-11-11T15:53:45.227Z",
                          "active_at": "2019-11-11T15:53:45.227Z",
                          "owner": "9ca8cbca-08e5-4547-a950-fe4842f77fe8",
                          "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                          "disabled": true
                        },
                        "phones": [
                          {
                            "phone_number": "16789408223",
                            "timezone": "America/New_York",
                            "title": "Harry Ryder",
                            "company": {
                              "id": 57,
                              "name": "AVS Internal",
                              "subdomain": "AVSInternal",
                              "status": 1,
                              "created_at": "2019-11-11T15:53:45.227Z",
                              "active_at": "2019-11-11T15:53:45.227Z",
                              "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                              "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                              "disabled": true
                            },
                            "id": 605,
                            "is_deleted": false,
                            "created_at": "2021-01-21T00:58:09.619Z",
                            "rateOfSend": 1
                          }
                        ],
                        "default_phone_id": 605,
                        "password_reset_token": null,
                        "passwords": null,
                        "id": "e5003d49-47b8-4f13-8da4-d547476251fa",
                        "display_as": "",
                        "notes": "",
                        "created": "2021-01-21T08:26:15.921Z"
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the User.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'e5003d49-47b8-4f13-8da4-d547476251fa']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `User email.`]
                      },
                      {
                        columns: ['Type', 'string']
                      },
                      {
                        columns: ['Example', 'test.busisness@gmail.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['send_email_invite', `Description`, `It send a welcome email to the Customer.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phones', `Description`, `It contain  phone info.`]
                      },
                      {
                        columns: ['Type', 'Array of object']
                      },
                      {
                        columns: ['Example', `[
                          {
                            "phone_number": "16789408223",
                            "timezone": "America/New_York",
                            "title": "Harry Ryder",
                            "company": {
                              "id": 57,
                              "name": "AVS Internal",
                              "subdomain": "AVSInternal",
                              "status": 1,
                              "created_at": "2019-11-11T15:53:45.227Z",
                              "active_at": "2019-11-11T15:53:45.227Z",
                              "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                              "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                              "disabled": true
                            },
                            "id": 605,
                            "is_deleted": false,
                            "created_at": "2021-01-21T00:58:09.619Z",
                            "rateOfSend": 1
                          }
                        ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Create User Using Existing Number": {
          title: 'Create User Using Existing Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create User Using Existing Number. Required fields are email, first name, last name, phone details, numberType is always 'NUMBER_USE_EXISTING' it's a fixed value, remaining fields are optional.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.COMMANDCENTER_API_URL}#Read#4`, detail: 'Click here to Get List of EXISTING Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/messageview/users/{customer_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['customer_id', `Description`, `Customer Id for which you need to create a user.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '303d68bc-2f15-4b18-b666-9197011a2f72']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/messageview/users/303d68bc-2f15-4b18-b666-9197011a2f72`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `User Email.`]
                      },
                      {
                        columns: ['Type', 'Email']
                      },
                      {
                        columns: ['Example', 'harry.henn@gmail.com']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`first_name`, `Description`, `First Name of the user.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'Harry']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`last_name`, `Description`, `Last Name of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Henn']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Harry Rocks']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`show_censor_contact`, `Description`, `Enable or Disable censor contact for the user.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'false']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 6,
                        columns: [`phone`, `Description`, `Put a valid number details please use above link to GET List of Existing NUMBER.`]
                      },
                      {
                        columns: ['owner', `Its a Customer Id for which need to assign a number, Customer Id must be same as ID in url.`]
                      },
                      {
                        columns: ['timezone', `Put any valid timezone for the numbers some of valid timezones are [America/New_York,"America/Los_Angeles","America/Chicago"].`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "phone_number": "19857451829",
                          "timezone": "America/New_York",
                          "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                      }`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`numberType`, `Description`, `This is fixed value need to send 'NUMBER_USE_EXISTING'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `NUMBER_USE_EXISTING`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "email": "harry.henn@gmail.com",
                      "first_name": "Harry",
                      "last_name": "Henn",
                      "title": "Harry Rocks",
                      "show_censor_contact": false,
                      "phone": {
                        "phone_number": "19857451829",
                        "timezone": "America/New_York",
                        "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                      },
                      "username": "Harry",
                      "numberType": "NUMBER_USE_EXISTING"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "username": "Harry",
                        "email": "harry.henn@gmail.com",
                        "password": "sha1$db42f4a9$1$e6f1b1ed371dc33d8c1b4b2759d1e2f0e3992b20",
                        "password_reset_expiries": "2021-01-24T13:04:16.602Z",
                        "send_email_invite": true,
                        "first_name": "Harry",
                        "last_name": "Henn",
                        "title": "Harry Rocks",
                        "auto_status": 0,
                        "custom_status": 0,
                        "registration_status": 1,
                        "must_change_password": true,
                        "password_changed_at": "2021-01-24T13:04:16.615Z",
                        "timezone": "",
                        "reports_to": "",
                        "status": 1,
                        "show_censor_contact": false,
                        "company": {
                          "id": 164,
                          "name": "Dummy Customer",
                          "subdomain": "DummyCustomer",
                          "status": 1,
                          "created_at": "2021-01-21T07:48:51.947Z",
                          "active_at": "2021-01-21T07:48:51.947Z",
                          "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                          "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                          "disabled": false
                        },
                        "phones": [
                          {
                            "id": 600,
                            "phone_number": "19857451829",
                            "title": "19857451829",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2021-01-20T22:05:41.920Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 164,
                              "name": "Dummy Customer",
                              "subdomain": "DummyCustomer",
                              "status": 1,
                              "created_at": "2021-01-21T07:48:51.947Z",
                              "active_at": "2021-01-21T07:48:51.947Z",
                              "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                              "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                              "disabled": false
                            }
                          }
                        ],
                        "default_phone_id": 600,
                        "password_reset_token": null,
                        "passwords": null,
                        "id": "1a54da37-5b9a-428f-b48c-9fbe7941996f",
                        "display_as": "",
                        "notes": "",
                        "created": "2021-01-24T12:33:16.722Z"
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the User.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '1a54da37-5b9a-428f-b48c-9fbe7941996f']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `User email.`]
                      },
                      {
                        columns: ['Type', 'string']
                      },
                      {
                        columns: ['Example', 'harry.henn@gmail.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['send_email_invite', `Description`, `It send a welcome email to the Customer.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phones', `Description`, `It contain  phone info.`]
                      },
                      {
                        columns: ['Type', 'Array of object']
                      },
                      {
                        columns: ['Example', `[
                          {
                            "id": 600,
                            "phone_number": "19857451829",
                            "title": "19857451829",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2021-01-20T22:05:41.920Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 164,
                              "name": "Dummy Customer",
                              "subdomain": "DummyCustomer",
                              "status": 1,
                              "created_at": "2021-01-21T07:48:51.947Z",
                              "active_at": "2021-01-21T07:48:51.947Z",
                              "owner": "303d68bc-2f15-4b18-b666-9197011a2f72",
                              "reseller": "debd116a-dde3-4541-9d89-83ed5734181b",
                              "disabled": false
                            }
                          }
                        ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        // "Create User Using CPAAS Inventory Number": {
        //   title: 'Create User Using CPAAS Inventory Number'
        // },
        "Update User": {
          title: 'Update User',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update User Using Existing Number. Required fields are email, first name, last name, phone details, numberType is always 'NUMBER_USE_EXISTING' it's a fixed value, remaining fields are optional.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.COMMANDCENTER_API_URL}#Read#4`, detail: 'Click here to Get List of EXISTING Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/messageview/users/{id}`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Id for which you need to update user.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${API_URL}/messageview/users/7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `User Email.`]
                      },
                      {
                        columns: ['Type', 'Email']
                      },
                      {
                        columns: ['Example', 'harry.henn@gmail.com']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`first_name`, `Description`, `First Name of the user.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', 'Harry']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`last_name`, `Description`, `Last Name of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Henn']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title of the user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Harry Rocks']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`show_censor_contact`, `Description`, `Enable or Disable censor contact for the user.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'false']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 6,
                        columns: [`phone`, `Description`, `Put a valid number details please use above link to GET List of Existing NUMBER.`]
                      },
                      {
                        columns: ['owner', `Its a Customer Id for which need to assign a number, Customer Id must be same as ID in url.`]
                      },
                      {
                        columns: ['timezone', `Put any valid timezone for the numbers some of valid timezones are [America/New_York,"America/Los_Angeles","America/Chicago"].`]
                      },
                      {
                        columns: ['Type', 'object']
                      },
                      {
                        columns: ['Example', `{
                          "phone_number": "19857451829",
                          "timezone": "America/New_York",
                          "owner": "303d68bc-2f15-4b18-b666-9197011a2f72"
                      }`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`numberType`, `Description`, `This is fixed value need to send 'NUMBER_USE_EXISTING'.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `NUMBER_USE_EXISTING`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "email": "harry.henn@gmail.com",
                      "first_name": "Harry",
                      "last_name": "Henn",
                      "title": "Harry Rocks",
                      "show_censor_contact": false,
                      "phone": {
                        "phone_number": "17324291200",
                        "timezone": "America/New_York",
                        "owner": "46c78c58-485d-4f54-a000-008ae791a116"
                      },
                      "username": "Harry",
                      "numberType": "NUMBER_USE_EXISTING"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "status": "ok",
                        "status_code": 200,
                        "data": {
                          "id": "7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23",
                          "email": "harry.henn@gmail.com",
                          "password_reset_token": null,
                          "auto_status": 3,
                          "custom_status": 0,
                          "registration_status": 1,
                          "must_change_password": true,
                          "first_name": "Nitesh",
                          "last_name": "Test",
                          "username": "Nitesh",
                          "title": "Nitesh User",
                          "display_as": "",
                          "notes": "",
                          "send_email_invite": false,
                          "timezone": "",
                          "status": 1,
                          "default_phone_id": 194,
                          "created": "2020-11-02T11:33:28.594Z",
                          "show_censor_contact": true,
                          "phones": [
                            {
                              "id": 194,
                              "phone_number": "17324291200",
                              "title": "17324291200",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-10-28T09:04:17.109Z",
                              "rateOfSend": 1,
                              "company": {
                                "id": 47,
                                "name": "Affiliated Engineering Labs",
                                "subdomain": "AffiliatedEngineeringLabs",
                                "status": 1,
                                "created_at": "2019-10-28T08:27:42.611Z",
                                "active_at": "2019-10-28T08:27:42.611Z",
                                "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                "disabled": false
                              }
                            }
                          ],
                          "roles": [],
                          "settings": {
                            "id": 299,
                            "notification_audible": false,
                            "notification_visual": false,
                            "theme_color": "",
                            "font_family": "{\"value\":\"Helvetica Neue\",\"label\":\"Helvetica Neue\"}",
                            "bubble_color": "#00BBE5",
                            "font_size": 16,
                            "email_send_time": 5,
                            "notification_email": false
                          },
                          "company": {
                            "id": 47,
                            "name": "Affiliated Engineering Labs",
                            "subdomain": "AffiliatedEngineeringLabs",
                            "status": 1,
                            "created_at": "2019-10-28T08:27:42.611Z",
                            "active_at": "2019-10-28T08:27:42.611Z",
                            "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                            "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                            "disabled": false,
                            "whitelabeling": {
                              "id": 14,
                              "application_name": "Affiliated Texting Service",
                              "cc_name": "Affiliated Command Center",
                              "logo_url": "//messageviewcdn-production.brightlink.com:443/lol/atslogo.png",
                              "favicon": "",
                              "primary_css_color": "#1369df",
                              "support_email": "phonesupport@affiliatedtech.com",
                              "support_phone": "8774471555",
                              "show_login_logo_cc": true,
                              "show_login_logo_mv": true,
                              "show_logo_cc": true,
                              "show_logo_mv": true,
                              "show_copywrite": true,
                              "show_help_link": true,
                              "show_terms_of_use_link": true,
                              "show_privacy_policy_link": true,
                              "partner_name": "Brightlink",
                              "privacy_policy_link_url": null
                            }
                          },
                          "isPasswordExpired": true,
                          "display_note": "Your password has expired. Please change it",
                          "numberType": "NUMBER_USE_EXISTING",
                          "activePhone": 45,
                          "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJiMWRmMjEyNC0zZjViLTQ1NjQtOGIyZC03NWMwYWU3ZTE1OTkiLCJwaG9uZV9pZCI6NDUsInJlbWVtYmVyTWUiOmZhbHNlfQ.OnNQNMO3UO62gHPZ3urEG-T8NWfwnnm2yJd3j9cq_rA",
                          "logout_after": null
                        }
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the User.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'a10ae915-4f1b-4a6d-be7a-e91521f29e45']
                      },
                      {
                        rowSpan: 3,
                        columns: ['email', `Description`, `User email.`]
                      },
                      {
                        columns: ['Type', 'string']
                      },
                      {
                        columns: ['Example', 'harry.henn@gmail.com']
                      },
                      {
                        rowSpan: 3,
                        columns: ['send_email_invite', `Description`, `It send a welcome email to the Customer.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'true']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phones', `Description`, `It contain  phone info.`]
                      },
                      {
                        columns: ['Type', 'Array of object']
                      },
                      {
                        columns: ['Example', ` [
                          {
                              "id": 194,
                              "phone_number": "17324291200",
                              "title": "17324291200",
                              "timezone": "America/New_York",
                              "is_deleted": false,
                              "created_at": "2019-10-28T09:04:17.109Z",
                              "rateOfSend": 1,
                              "company": {
                                  "id": 47,
                                  "name": "Affiliated Engineering Labs",
                                  "subdomain": "AffiliatedEngineeringLabs",
                                  "status": 1,
                                  "created_at": "2019-10-28T08:27:42.611Z",
                                  "active_at": "2019-10-28T08:27:42.611Z",
                                  "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                  "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                  "disabled": false
                              }
                          }
                      ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Create New Number": {
          title: 'Create New Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Number Using New Number. Required fields are list of numbers, customer_id for which you need to register for the number.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.COMMANDCENTER_API_URL}#Read#6`, detail: 'Click here to Get New Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/order`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`customer_id`, `Description`, `Customer Id for which you need to create a Number.`]
                      },
                      {
                        columns: ['Type', "uuid"]
                      },
                      {
                        columns: ['Example', '46c78c58-485d-4f54-a000-008ae791a116']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`numbers`, `Description`, `List of Numbers.`]
                      },
                      {
                        columns: ['Type', 'Array of Number']
                      },
                      {
                        columns: ['Example', `[
                          "19857451821",
                          "19857451824"
                      ]`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "customer_id": "46c78c58-485d-4f54-a000-008ae791a116",
                      "numbers": [
                        "19857451823",
                        "19857451822"
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "data": {
                        "id": 361,
                        "cpaasid": "17526",
                        "pon": "mytest-qa-8040774f-5",
                        "created_at": "2021-01-24T13:29:40.981Z",
                        "customer_id": "46c78c58-485d-4f54-a000-008ae791a116",
                        "uid": {
                          "name": "Joe"
                        },
                        "numbers": [
                          "19859001471"
                        ],
                        "customer": {
                          "name": "Affiliated Engineering Labs",
                          "partner": null
                        },
                        "status": "DRAFT"
                      },
                      "status": "ok"
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '361']
                      },
                      {
                        rowSpan: 3,
                        columns: ['customer', 'Description', 'Customer Details.']
                      },
                      {
                        columns: ['Type', 'Object']
                      },
                      {
                        columns: ['Example', `{
                          "name": "Affiliated Engineering Labs",
                          "partner": null
                        }`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['numbers', 'Description', 'Customer Details.']
                      },
                      {
                        columns: ['Type', 'Array of Numbers.']
                      },
                      {
                        columns: ['Example', `[
                          "19859001471"
                        ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        // "Create CPAAS Inventory Number": {
        //   title: 'Create CPAAS Inventory Number'
        // },
        // "Create Busisness Number": {
        //   title: 'Create Busisness Number' ,
        //   parentTags: [
        //     {
        //       P: {
        //         detail: "This is a REST API for Create Number Using New Number. Required fields are list of numbers, customer_id for which you need to register for the number.",
        //         childTags: [
        //           { key: P },
        //           { key: A, link: `${API_FRONTEND_ACCESS_URL.COMMANDCENTER_API_URL}#Read#6`, detail: 'Click here to Get New Number.' }
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: "Request" },
        //           {
        //             key: TABLE,
        //             rows: [
        //               {
        //                 columns: ['Endpoint:', `${API_URL}/order`]
        //               },
        //               {
        //                 columns: ['Method:', 'POST']
        //               },
        //               {
        //                 columns: ['Headers:', 'Authorization: Bearer <access_token>']
        //               }
        //             ]
        //           }
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: 'Request Body' },
        //           { key: H4, detail: 'Example:' },
        //           {
        //             key: JSON, detail: {
        //               "customer_id": "46c78c58-485d-4f54-a000-008ae791a116",
        //               "numbers": [
        //                 "19857451823",
        //                 "19857451822"
        //               ]
        //             }
        //           },
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: "POST Request Body Data" },
        //           {
        //             key: TABLE,
        //             rows: [
        //               {
        //                 rowSpan: 4,
        //                 columns: [`customer_id`, `Description`, `Customer Id for which you need to create a Number.`]
        //               },
        //               {
        //                 columns: ['Type', "uuid"]
        //               },
        //               {
        //                 columns: ['Example', '46c78c58-485d-4f54-a000-008ae791a116']
        //               },
        //               {
        //                 columns: ['Required', 'Yes']
        //               },
        //               {
        //                 rowSpan: 4,
        //                 columns: [`numbers`, `Description`, `List of Numbers.`]
        //               },
        //               {
        //                 columns: ['Type', 'Array of Number']
        //               },
        //               {
        //                 columns: ['Example', `[
        //                   "19857451821",
        //                   "19857451824"
        //               ]`]
        //               },
        //               {
        //                 columns: ['Required', 'Yes']
        //               }
        //             ]
        //           }
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           { key: H3, detail: 'Response' },
        //           { key: H4, detail: 'Example:' },
        //           {
        //             key: JSON, detail: {
        //               "data": {
        //                 "id": 361,
        //                 "cpaasid": "17526",
        //                 "pon": "mytest-qa-8040774f-5",
        //                 "created_at": "2021-01-24T13:29:40.981Z",
        //                 "customer_id": "46c78c58-485d-4f54-a000-008ae791a116",
        //                 "uid": {
        //                   "name": "Joe"
        //                 },
        //                 "numbers": [
        //                   "19859001471"
        //                 ],
        //                 "customer": {
        //                   "name": "Affiliated Engineering Labs",
        //                   "partner": null
        //                 },
        //                 "status": "DRAFT"
        //               },
        //               "status": "ok"
        //             }
        //           }
        //         ]
        //       }
        //     },
        //     {
        //       SECTION: {
        //         childTags: [
        //           {
        //             key: TABLE,
        //             rows: [
        //               {
        //                 rowSpan: 3,
        //                 columns: ['id', `Description`, `Its unique Id for the Phone Number.`]
        //               },
        //               {
        //                 columns: ['Type', 'Integer']
        //               },
        //               {
        //                 columns: ['Example', '361']
        //               },
        //               {
        //                 rowSpan: 3,
        //                 columns: ['customer', 'Description', 'Customer Details.']
        //               },
        //               {
        //                 columns: ['Type', 'Object']
        //               },
        //               {
        //                 columns: ['Example', `{
        //                   "name": "Affiliated Engineering Labs",
        //                   "partner": null
        //                 }`]
        //               },
        //               {
        //                 rowSpan: 3,
        //                 columns: ['numbers', 'Description', 'Customer Details.']
        //               },
        //               {
        //                 columns: ['Type', 'Array of Numbers.']
        //               },
        //               {
        //                 columns: ['Example', `[
        //                   "19859001471"
        //                 ]`]
        //               }
        //             ]
        //           }
        //         ]
        //       }
        //     }
        //   ]
        // },
        "Update Number": {
          title: 'Update Number',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Phone Number. Required fields are id, title, rateOfSend, remaining fields are optional.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.COMMANDCENTER_API_URL}#Read#2`, detail: 'Click here to Get List of User assigned to Customer Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${API_URL}/phone`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "PUT Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`id`, `Description`, `Phone Id for which you need to update details.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 608]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `title of Phone Number.`]
                      },
                      {
                        columns: ['Type', "String"]
                      },
                      {
                        columns: ['Example', '19857451823']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`rateOfSend`, `Description`, `Number of SMS/MMS Sends in 1 Second.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`timezone`, `Description`, `Put any valid timezone for the numbers some of valid timezones are [America/New_York,"America/Los_Angeles","America/Chicago"].`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'America/New_York']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`users`, `Description`, `Select user id, which you need to assign to the phone number.`]
                      },
                      {
                        columns: ['Type', 'Array of uuid']
                      },
                      {
                        columns: ['Example', `["7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23",
                        "4470a52a-155a-4cf1-8bba-caf6b7a5b2c3"]`]
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": 608,
                      "title": "19857451823",
                      "rateOfSend": 1,
                      "timezone": "America/New_York",
                      "users": [
                        "7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23",
                        "4470a52a-155a-4cf1-8bba-caf6b7a5b2c3"
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 201,
                      "data": {
                        "id": 608,
                        "phone_number": "19857451823",
                        "title": "19857451823",
                        "timezone": "America/New_York",
                        "is_deleted": false,
                        "created_at": "2021-01-23T23:46:05.852Z",
                        "rateOfSend": 1,
                        "company": {
                          "id": 47,
                          "name": "Affiliated Engineering Labs",
                          "subdomain": "AffiliatedEngineeringLabs",
                          "status": 1,
                          "created_at": "2019-10-28T08:27:42.611Z",
                          "active_at": "2019-10-28T08:27:42.611Z",
                          "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                          "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                          "disabled": false
                        },
                        "users": [
                          {
                            "id": "7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23",
                            "email": "nitesh.test23@gmail.com",
                            "password": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f",
                            "password_reset_expiries": "2020-11-02T11:34:01.759Z",
                            "password_reset_token": null,
                            "auto_status": 3,
                            "custom_status": 0,
                            "registration_status": 1,
                            "must_change_password": true,
                            "password_changed_at": "2021-01-06T06:06:59.049Z",
                            "first_name": "Nitesh",
                            "last_name": "Test",
                            "username": "Nitesh",
                            "title": "Nitesh User",
                            "display_as": "",
                            "notes": "",
                            "send_email_invite": false,
                            "timezone": "",
                            "reports_to": "",
                            "status": 1,
                            "default_phone_id": 194,
                            "passwords": [
                              {
                                "date": "2020-11-02T11:34:01.873Z",
                                "hash": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f"
                              }
                            ],
                            "created": "2020-11-02T11:33:28.594Z",
                            "show_censor_contact": true,
                            "phones": [
                              {
                                "id": 194,
                                "phone_number": "17324291200",
                                "title": "17324291200",
                                "timezone": "America/New_York",
                                "is_deleted": false,
                                "created_at": "2019-10-28T09:04:17.109Z",
                                "rateOfSend": 1,
                                "company": {
                                  "id": 47,
                                  "name": "Affiliated Engineering Labs",
                                  "subdomain": "AffiliatedEngineeringLabs",
                                  "status": 1,
                                  "created_at": "2019-10-28T08:27:42.611Z",
                                  "active_at": "2019-10-28T08:27:42.611Z",
                                  "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                  "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                  "disabled": false
                                }
                              },
                              {
                                "id": 608,
                                "phone_number": "19857451823",
                                "title": "19857451823",
                                "timezone": "America/New_York",
                                "is_deleted": false,
                                "created_at": "2021-01-23T23:46:05.852Z",
                                "rateOfSend": 1,
                                "company": {
                                  "id": 47,
                                  "name": "Affiliated Engineering Labs",
                                  "subdomain": "AffiliatedEngineeringLabs",
                                  "status": 1,
                                  "created_at": "2019-10-28T08:27:42.611Z",
                                  "active_at": "2019-10-28T08:27:42.611Z",
                                  "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                  "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                  "disabled": false
                                }
                              }
                            ],
                            "tempPassword": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f",
                            "isPasswordExpired": true,
                            "display_note": "Your password has expired. Please change it"
                          },
                          {
                            "id": "4470a52a-155a-4cf1-8bba-caf6b7a5b2c3",
                            "email": "nitesh.test1@gmail.com",
                            "password": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f",
                            "password_reset_expiries": "2020-11-02T11:35:06.740Z",
                            "password_reset_token": null,
                            "auto_status": 0,
                            "custom_status": 0,
                            "registration_status": 1,
                            "must_change_password": true,
                            "password_changed_at": "2020-11-02T11:35:06.752Z",
                            "first_name": "Nitesh",
                            "last_name": "Test1",
                            "username": "Nitesh",
                            "title": "",
                            "display_as": "",
                            "notes": "",
                            "send_email_invite": true,
                            "timezone": "",
                            "reports_to": "",
                            "status": 1,
                            "default_phone_id": 194,
                            "passwords": [],
                            "created": "2020-11-02T11:33:28.594Z",
                            "show_censor_contact": false,
                            "phones": [
                              {
                                "id": 194,
                                "phone_number": "17324291200",
                                "title": "17324291200",
                                "timezone": "America/New_York",
                                "is_deleted": false,
                                "created_at": "2019-10-28T09:04:17.109Z",
                                "rateOfSend": 1,
                                "company": {
                                  "id": 47,
                                  "name": "Affiliated Engineering Labs",
                                  "subdomain": "AffiliatedEngineeringLabs",
                                  "status": 1,
                                  "created_at": "2019-10-28T08:27:42.611Z",
                                  "active_at": "2019-10-28T08:27:42.611Z",
                                  "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                  "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                  "disabled": false
                                }
                              },
                              {
                                "id": 608,
                                "phone_number": "19857451823",
                                "title": "19857451823",
                                "timezone": "America/New_York",
                                "is_deleted": false,
                                "created_at": "2021-01-23T23:46:05.852Z",
                                "rateOfSend": 1,
                                "company": {
                                  "id": 47,
                                  "name": "Affiliated Engineering Labs",
                                  "subdomain": "AffiliatedEngineeringLabs",
                                  "status": 1,
                                  "created_at": "2019-10-28T08:27:42.611Z",
                                  "active_at": "2019-10-28T08:27:42.611Z",
                                  "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                  "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                  "disabled": false
                                }
                              }
                            ],
                            "tempPassword": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f",
                            "isPasswordExpired": true,
                            "display_note": "Your password has expired. Please change it"
                          }
                        ]
                      }
                    }
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Update Phone NUmber id.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '608']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '19857451823']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Title of Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '19857451823']
                      },
                      {
                        rowSpan: 3,
                        columns: ['timezone', `Description`, `Timezone of a phone number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `America/New_York`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['rateOfSend', `Description`, `Send Number of SMS/MMS in 1 second.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', `1`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['users', `Description`, `Array of assigned user.`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": "7cdbfbdb-7eb4-43fb-be59-20dd5bf5fb23",
                              "email": "nitesh.test23@gmail.com",
                              "password": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f",
                              "password_reset_expiries": "2020-11-02T11:34:01.759Z",
                              "password_reset_token": null,
                              "auto_status": 3,
                              "custom_status": 0,
                              "registration_status": 1,
                              "must_change_password": true,
                              "password_changed_at": "2021-01-06T06:06:59.049Z",
                              "first_name": "Nitesh",
                              "last_name": "Test",
                              "username": "Nitesh",
                              "title": "Nitesh User",
                              "display_as": "",
                              "notes": "",
                              "send_email_invite": false,
                              "timezone": "",
                              "reports_to": "",
                              "status": 1,
                              "default_phone_id": 194,
                              "passwords": [
                                  {
                                      "date": "2020-11-02T11:34:01.873Z",
                                      "hash": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f"
                                  }
                              ],
                              "created": "2020-11-02T11:33:28.594Z",
                              "show_censor_contact": true,
                              "phones": [
                                  {
                                      "id": 194,
                                      "phone_number": "17324291200",
                                      "title": "17324291200",
                                      "timezone": "America/New_York",
                                      "is_deleted": false,
                                      "created_at": "2019-10-28T09:04:17.109Z",
                                      "rateOfSend": 1,
                                      "company": {
                                          "id": 47,
                                          "name": "Affiliated Engineering Labs",
                                          "subdomain": "AffiliatedEngineeringLabs",
                                          "status": 1,
                                          "created_at": "2019-10-28T08:27:42.611Z",
                                          "active_at": "2019-10-28T08:27:42.611Z",
                                          "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                          "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                          "disabled": false
                                      }
                                  },
                                  {
                                      "id": 608,
                                      "phone_number": "19857451823",
                                      "title": "19857451823",
                                      "timezone": "America/New_York",
                                      "is_deleted": false,
                                      "created_at": "2021-01-23T23:46:05.852Z",
                                      "rateOfSend": 1,
                                      "company": {
                                          "id": 47,
                                          "name": "Affiliated Engineering Labs",
                                          "subdomain": "AffiliatedEngineeringLabs",
                                          "status": 1,
                                          "created_at": "2019-10-28T08:27:42.611Z",
                                          "active_at": "2019-10-28T08:27:42.611Z",
                                          "owner": "46c78c58-485d-4f54-a000-008ae791a116",
                                          "reseller": "7ee6b90c-145b-462c-bcf2-67cdc6cd29ee",
                                          "disabled": false
                                      }
                                  }
                              ],
                              "tempPassword": "sha1$1958f388$1$6f26327fe35aca254bffa119b8e78085c7ff655f",
                              "isPasswordExpired": true,
                              "display_note": "Your password has expired. Please change it"
                          }
                      ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        }
      }
    }
  }
});

export const getMessageviewData = () => ({
  sidebarLinks: {
    Authentication: {
      chlidLinks: {
        "Authorization": {
          title: 'Authorization',
          parentTags: [
            {
              P: {
                detail: "To verify incoming API requests, Brightlink's APIs use access tokens, these access tokens are handled by JWT.The API uses JWT access tokens to access all secure endpoints. Access tokens can be requested via the end point as detailed below. The access token is required as a Bearer token for all the other APIs."
              }
            }
          ]
        },
        "Permission": {
          title: 'Permission',
          parentTags: [
            {
              P: {
                detail: "The permissions of an access token will be based upon the client that requested the token. The access token is issued against a user account in the Brightlink portal. The API access permissions will mirror the permissions set for the user in the portal."
              }
            }
          ]
        },
        "Obtaining Access Token": {
          title: 'Obtaining an Access Token',
          parentTags: [
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/login`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Content-Type: application/json']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `Enter a valid email that is registered to the Messageview.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'test@gmail.com']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`password`, `Description`, `Enter a valid password.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Test@1234']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`remember_me`, `Description`, `Remember the access Token for 1 Month.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', 'true/false']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "email": "test@gmail.com",
                      "password": "Test@1234",
                      "remember_me": true
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": "b1df2124-3f5b-4564-8b2d-75c0ae7e1599",
                      "email": "test@gmail.com",
                      "password_reset_token": null,
                      "auto_status": 1,
                      "custom_status": 0,
                      "registration_status": 1,
                      "must_change_password": false,
                      "first_name": "Test",
                      "last_name": "User",
                      "username": "Test user",
                      "title": "Test",
                      "display_as": "Jack",
                      "notes": "",
                      "send_email_invite": false,
                      "timezone": "",
                      "status": 1,
                      "default_phone_id": 14,
                      "created": "2019-06-12T13:59:29.106Z",
                      "show_censor_contact": false,
                      "phones": [
                        {
                          "id": 251,
                          "phone_number": "18032918428",
                          "title": "18032918428",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2019-11-25T11:08:25.121Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 1,
                            "name": "Brightlink",
                            "subdomain": "brightlink",
                            "status": 1,
                            "created_at": "2019-04-26T12:23:28.582Z",
                            "active_at": "2019-04-26T12:23:28.582Z",
                            "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                            "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                            "disabled": false
                          },
                          "blacklisted": []
                        },
                        {
                          "id": 46,
                          "phone_number": "18888714575",
                          "title": "Brightlink Main",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 1,
                            "name": "Brightlink",
                            "subdomain": "brightlink",
                            "status": 1,
                            "created_at": "2019-04-26T12:23:28.582Z",
                            "active_at": "2019-04-26T12:23:28.582Z",
                            "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                            "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                            "disabled": false
                          },
                          "blacklisted": []
                        },
                        {
                          "id": 45,
                          "phone_number": "18337294255",
                          "title": "PBX4ALL",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 1,
                            "name": "Brightlink",
                            "subdomain": "brightlink",
                            "status": 1,
                            "created_at": "2019-04-26T12:23:28.582Z",
                            "active_at": "2019-04-26T12:23:28.582Z",
                            "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                            "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                            "disabled": false
                          },
                          "blacklisted": []
                        },
                        {
                          "id": 44,
                          "phone_number": "18337674255",
                          "title": "SMS4ALL",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 1,
                            "name": "Brightlink",
                            "subdomain": "brightlink",
                            "status": 1,
                            "created_at": "2019-04-26T12:23:28.582Z",
                            "active_at": "2019-04-26T12:23:28.582Z",
                            "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                            "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                            "disabled": false
                          },
                          "blacklisted": []
                        },
                        {
                          "id": 14,
                          "phone_number": "14043341185",
                          "title": "Tri Phan",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 1,
                            "name": "Brightlink",
                            "subdomain": "brightlink",
                            "status": 1,
                            "created_at": "2019-04-26T12:23:28.582Z",
                            "active_at": "2019-04-26T12:23:28.582Z",
                            "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                            "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                            "disabled": false
                          },
                          "blacklisted": []
                        }
                      ],
                      "roles": [],
                      "settings": {
                        "id": 9,
                        "notification_audible": true,
                        "notification_visual": true,
                        "theme_color": "#004B87",
                        "font_family": "{\"value\":\"Helvetica Neue\",\"label\":\"Helvetica Neue\"}",
                        "bubble_color": "#00BBE5",
                        "font_size": 16,
                        "email_send_time": 5,
                        "notification_email": false
                      },
                      "company": {
                        "id": 1,
                        "name": "Brightlink",
                        "subdomain": "brightlink",
                        "status": 1,
                        "created_at": "2019-04-26T12:23:28.582Z",
                        "active_at": "2019-04-26T12:23:28.582Z",
                        "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                        "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                        "disabled": false
                      },
                      "isPasswordExpired": false,
                      "activePhone": 14,
                      "rememberMe": false,
                      "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiJiMWRmMjEyNC0zZjViLTQ1NjQtOGIyZC03NWMwYWU3ZTE1OTkiLCJwaG9uZV9pZCI6MTQsInJlbWVtYmVyTWUiOmZhbHNlLCJpYXQiOjE2MTI3ODc4NzcsImV4cCI6MTYyMDU2Mzg3N30.zVpjGIvJYZB6qHbHE7bTES6qq7CuoqtW8QHH1YfBwgQ",
                      "logout_after": 129600
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`phones`, `Description`, `Active Phone Number available to the User account.`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `[
                          {
                            "id": 251,
                            "phone_number": "18032918428",
                            "title": "18032918428",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-11-25T11:08:25.121Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 1,
                              "name": "Brightlink",
                              "subdomain": "brightlink",
                              "status": 1,
                              "created_at": "2019-04-26T12:23:28.582Z",
                              "active_at": "2019-04-26T12:23:28.582Z",
                              "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                              "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                              "disabled": false
                            },
                            "blacklisted": []
                          },
                          {
                            "id": 46,
                            "phone_number": "18888714575",
                            "title": "Brightlink Main",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 1,
                              "name": "Brightlink",
                              "subdomain": "brightlink",
                              "status": 1,
                              "created_at": "2019-04-26T12:23:28.582Z",
                              "active_at": "2019-04-26T12:23:28.582Z",
                              "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                              "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                              "disabled": false
                            },
                            "blacklisted": []
                          },
                          {
                            "id": 45,
                            "phone_number": "18337294255",
                            "title": "PBX4ALL",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 1,
                              "name": "Brightlink",
                              "subdomain": "brightlink",
                              "status": 1,
                              "created_at": "2019-04-26T12:23:28.582Z",
                              "active_at": "2019-04-26T12:23:28.582Z",
                              "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                              "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                              "disabled": false
                            },
                            "blacklisted": []
                          },
                          {
                            "id": 44,
                            "phone_number": "18337674255",
                            "title": "SMS4ALL",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 1,
                              "name": "Brightlink",
                              "subdomain": "brightlink",
                              "status": 1,
                              "created_at": "2019-04-26T12:23:28.582Z",
                              "active_at": "2019-04-26T12:23:28.582Z",
                              "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                              "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                              "disabled": false
                            },
                            "blacklisted": []
                          },
                          {
                            "id": 14,
                            "phone_number": "14043341185",
                            "title": "Tri Phan",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "company": {
                              "id": 1,
                              "name": "Brightlink",
                              "subdomain": "brightlink",
                              "status": 1,
                              "created_at": "2019-04-26T12:23:28.582Z",
                              "active_at": "2019-04-26T12:23:28.582Z",
                              "owner": "1f756fd5-7408-42d5-94f6-2938871a30a4",
                              "reseller": "4eddecb9-0b9f-4a20-9901-16cc02e4f0ed",
                              "disabled": false
                            },
                            "blacklisted": []
                          }
                        ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: [`token`, `Description`, `The access token to send in the Authorization Bearer header.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiIyY2Q4ZWFkNS1mYTJhLTQzZGMtYmY5Mi0yZTc0YmViNDBlNTIiLCJyZW1lbWJlck1lIjp0cnVlLCJpYXQiOjE2MTA1NDQ4NDQsImV4cCI6MTYxMzEzNjg0NH0.4SJ7mQWqEVnk96vS98tjM3wTfvvC07rHh6mgxTh0JjQ']
                      },
                      {
                        rowSpan: 3,
                        columns: [`settings`, `Description`, `Setting details assign to the user.`]
                      },
                      {
                        columns: ['Type', 'Object']
                      },
                      {
                        columns: ['Example', `{
                          "id": 9,
                          "notification_audible": true,
                          "notification_visual": true,
                          "theme_color": "#004B87",
                          "font_family": "{\"value\":\"Helvetica Neue\",\"label\":\"Helvetica Neue\"}",
                          "bubble_color": "#00BBE5",
                          "font_size": 16,
                          "email_send_time": 5,
                          "notification_email": false
                        }`]
                      }
                    ]
                  }
                ]
              }
            },
          ]
        },
      }
    },
    Read: {
      chlidLinks: {
        "User's Numbers": {
          title: `User's Number List`,
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Phones List associated with the Logged in User."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user_phones`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user_phones`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": [
                        {
                          "id": 14,
                          "phone_number": "14043341185",
                          "title": "Tri Phan",
                          "timezone": "America/New_York",
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1
                        },
                        {
                          "id": 45,
                          "phone_number": "18337294255",
                          "title": "PBX4ALL",
                          "timezone": "America/New_York",
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1
                        },
                        {
                          "id": 44,
                          "phone_number": "18337674255",
                          "title": "SMS4ALL",
                          "timezone": "America/New_York",
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1
                        },
                        {
                          "id": 46,
                          "phone_number": "18888714575",
                          "title": "Brightlink Main",
                          "timezone": "America/New_York",
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1
                        },
                        {
                          "id": 251,
                          "phone_number": "18032918428",
                          "title": "18032918428",
                          "timezone": "America/New_York",
                          "created_at": "2019-11-25T11:08:25.121Z",
                          "rateOfSend": 1
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`status_code`, `Description`, `HTTP response status codes indicate whether a specific HTTP request has been successfully completed.`]
                      },
                      {
                        columns: ['Type', 'Number']
                      },
                      {
                        columns: ['Example', 200]
                      },
                      {
                        rowSpan: 3,
                        columns: ['data', `Description`, `Phone list asscoxiated with the Logged in user.`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `[
                          {
                            "id": 14,
                            "phone_number": "14043341185",
                            "title": "Tri Phan",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1
                          },
                          {
                            "id": 45,
                            "phone_number": "18337294255",
                            "title": "PBX4ALL",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1
                          },
                          {
                            "id": 44,
                            "phone_number": "18337674255",
                            "title": "SMS4ALL",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1
                          },
                          {
                            "id": 46,
                            "phone_number": "18888714575",
                            "title": "Brightlink Main",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1
                          },
                          {
                            "id": 251,
                            "phone_number": "18032918428",
                            "title": "18032918428",
                            "timezone": "America/New_York",
                            "created_at": "2019-11-25T11:08:25.121Z",
                            "rateOfSend": 1
                          }
                        ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '45']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '18337294255']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Phone Title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'PBX4ALL']
                      },
                      {
                        rowSpan: 3,
                        columns: ['timezone', `Description`, `Phone Timezone.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'America/New_York']
                      },
                      {
                        rowSpan: 3,
                        columns: ['rateOfSend', `Description`, `Number of SMS/MMS Sends in 1 Second.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Unread Messages Count": {
          title: `Count of Unread Messages`,
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Unread Messages Count associated with the Logged in User."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/unread_messages_count`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/unread_messages_count`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "unread_messages_count": 2,
                      "data": {
                        "phones": [
                          {
                            "id": 14,
                            "phone_number": "14043341185",
                            "title": "Tri Phan",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "unread_messages_count": 2
                          },
                          {
                            "id": 45,
                            "phone_number": "18337294255",
                            "title": "PBX4ALL",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "unread_messages_count": 0
                          },
                          {
                            "id": 44,
                            "phone_number": "18337674255",
                            "title": "SMS4ALL",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "unread_messages_count": 0
                          },
                          {
                            "id": 46,
                            "phone_number": "18888714575",
                            "title": "Brightlink Main",
                            "timezone": "America/New_York",
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1,
                            "unread_messages_count": 0
                          },
                          {
                            "id": 251,
                            "phone_number": "18032918428",
                            "title": "18032918428",
                            "timezone": "America/New_York",
                            "created_at": "2019-11-25T11:08:25.121Z",
                            "rateOfSend": 1,
                            "unread_messages_count": 0
                          }
                        ]
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`status_code`, `Description`, `HTTP response status codes indicate whether a specific HTTP request has been successfully completed.`]
                      },
                      {
                        columns: ['Type', 'Number']
                      },
                      {
                        columns: ['Example', 200]
                      },
                      {
                        rowSpan: 3,
                        columns: [`unread_messages_count`, `Description`, `Total Number of Unread Messages Count.`]
                      },
                      {
                        columns: ['Type', 'Number']
                      },
                      {
                        columns: ['Example', 2]
                      },
                      {
                        rowSpan: 3,
                        columns: ['data', `Description`, `Phone list asscoxiated with the Logged in user.`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": 14,
                              "phone_number": "14043341185",
                              "title": "Tri Phan",
                              "timezone": "America/New_York",
                              "created_at": "2019-07-16T09:19:27.938Z",
                              "rateOfSend": 1,
                              "unread_messages_count": 2
                          },
                          {
                              "id": 45,
                              "phone_number": "18337294255",
                              "title": "PBX4ALL",
                              "timezone": "America/New_York",
                              "created_at": "2019-07-16T09:19:27.938Z",
                              "rateOfSend": 1,
                              "unread_messages_count": 0
                          },
                          {
                              "id": 44,
                              "phone_number": "18337674255",
                              "title": "SMS4ALL",
                              "timezone": "America/New_York",
                              "created_at": "2019-07-16T09:19:27.938Z",
                              "rateOfSend": 1,
                              "unread_messages_count": 0
                          },
                          {
                              "id": 46,
                              "phone_number": "18888714575",
                              "title": "Brightlink Main",
                              "timezone": "America/New_York",
                              "created_at": "2019-07-16T09:19:27.938Z",
                              "rateOfSend": 1,
                              "unread_messages_count": 0
                          },
                          {
                              "id": 251,
                              "phone_number": "18032918428",
                              "title": "18032918428",
                              "timezone": "America/New_York",
                              "created_at": "2019-11-25T11:08:25.121Z",
                              "rateOfSend": 1,
                              "unread_messages_count": 0
                          }
                      ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `ID of Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '45']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '18337294255']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Phone Title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'PBX4ALL']
                      },
                      {
                        rowSpan: 3,
                        columns: ['timezone', `Description`, `Phone Timezone.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'America/New_York']
                      },
                      {
                        rowSpan: 3,
                        columns: ['rateOfSend', `Description`, `Number of SMS/MMS Sends in 1 Second.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 1]
                      },
                      {
                        rowSpan: 3,
                        columns: ['unread_messages_count', `Description`, `Number of Unread Message Count for the Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 0]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Contact List": {
          title: 'Contact List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Contact List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user_contacts/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Contact Details.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user_contacts/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "id": 207,
                        "first_name": "MessageView Monitor",
                        "last_name": "",
                        "username": "MessageView Monitor",
                        "display_as": "MessageView Monitor",
                        "is_phone": true,
                        "phone_number": "14043341244",
                        "is_deleted": false
                      },
                      {
                        "id": 422,
                        "first_name": "14049638482",
                        "last_name": "",
                        "username": "14049638482",
                        "display_as": "14049638482",
                        "is_phone": true,
                        "phone_number": "14049638482",
                        "is_deleted": false
                      },
                      {
                        "id": 440,
                        "first_name": "14043341159",
                        "last_name": "",
                        "username": "14043341159",
                        "display_as": "14043341159",
                        "is_phone": true,
                        "phone_number": "14043341159",
                        "is_deleted": false
                      },
                      {
                        "id": 441,
                        "first_name": "14043341181",
                        "last_name": "",
                        "username": "14043341181",
                        "display_as": "14043341181",
                        "is_phone": true,
                        "phone_number": "14043341181",
                        "is_deleted": false
                      }
                    ]
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Contact Id.`]
                      },
                      {
                        columns: ['Type', 'Number']
                      },
                      {
                        columns: ['Example', 207]
                      },
                      {
                        rowSpan: 3,
                        columns: ['first_name', `Description`, `First Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `MessageView Monitor`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '14043341244']
                      },
                      {
                        rowSpan: 3,
                        columns: ['display_as', `Description`, `Contact Display Name.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'MessageView Monitor']
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Blast List": {
          title: 'Blast List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Blast List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user_blast/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Blast Details.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user_blast/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": [
                        {
                          "id": "2624a49c-0bbb-49ab-bfb8-c14d76e0238a",
                          "name": "Blast List",
                          "notes": "",
                          "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                          "receive_compliance": [],
                          "stopped": [],
                          "is_deleted": false,
                          "created": "2021-02-08T14:58:49.971Z",
                          "csv_filename": "",
                          "sent_at": null,
                          "internal": {
                            "id": 44,
                            "phone_number": "18337674255",
                            "title": "SMS4ALL",
                            "timezone": "America/New_York",
                            "is_deleted": false,
                            "created_at": "2019-07-16T09:19:27.938Z",
                            "rateOfSend": 1
                          },
                          "external": [
                            {
                              "id": 345630,
                              "title": "Joanna Verizon",
                              "phone_number": "17703107513"
                            }
                          ]
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Blast Id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '2624a49c-0bbb-49ab-bfb8-c14d76e0238a']
                      },
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Name of the Blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Blast List`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['compliance', `Description`, `compliance message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Message and data rates may apply.\nReply STOP to end or HELP for more options.']
                      },
                      {
                        rowSpan: 3,
                        columns: ['external', `Description`, `Blast list external Phone Number.`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `[
                          {
                              "id": 345630,
                              "title": "Joanna Verizon",
                              "phone_number": "17703107513"
                          }
                      ]`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Auto Replies List": {
          title: 'Auto Replies List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Auto Replies List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/autoreplies`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Auto Replies.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/autoreplies`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "id": 336,
                        "keyword": "hello",
                        "exact_match": true,
                        "title": "Auto Reply Title",
                        "text_content": "Hi 😊",
                        "start_at": "2021-02-08T20:49:05.000Z",
                        "end_at": "2021-02-08T20:49:05.000Z",
                        "use_keywords": true,
                        "is_active": true,
                        "send_to_contacts": true,
                        "send_to_all": true,
                        "media_link": "https://messageviewminio-staging.brightlink.com/lol/9d242251-7436-4fc5-9112-1907771d9f74.jpeg",
                        "media_type": 0,
                        "type": 2,
                        "recurring_replies": [
                          {
                            "dayName": "Monday",
                            "isValid": false,
                            "isActive": false
                          },
                          {
                            "dayName": "Tuesday",
                            "isValid": false,
                            "isActive": false
                          },
                          {
                            "dayName": "Wednesday",
                            "isValid": false,
                            "isActive": false
                          },
                          {
                            "dayName": "Thursday",
                            "isValid": false,
                            "isActive": false
                          },
                          {
                            "dayName": "Friday",
                            "isValid": false,
                            "isActive": false
                          },
                          {
                            "dayName": "Saturday",
                            "isValid": false,
                            "isActive": false
                          },
                          {
                            "dayName": "Sunday",
                            "isValid": false,
                            "isActive": false
                          }
                        ],
                        "file_Name": "ringaro-logo.jpg",
                        "file_Size": "33.09 KB",
                        "media_file_mime": "image/jpeg",
                        "keywords": [
                          "hello",
                          "hi"
                        ]
                      }
                    ]
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Auto Reply Id.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '336']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Auto Reply title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Auto Reply Title`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['keywords', `Description`, `keyword for which auto reply works.`]
                      },
                      {
                        columns: ['Type', 'Array of String']
                      },
                      {
                        columns: ['Example', `[
                          "hello",
                          "hi"
                        ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['exact_match', `Description`, `Exact Match means auto reply works only if exact mach found for the keywords.`]
                      },
                      {
                        columns: ['Type', 'Boolean']
                      },
                      {
                        columns: ['Example', `true`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['text_content', `Description`, `Text Content mean text need to send in auto reply.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Hi 😊`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['media_link', `Description`, `Media link mean media need to send in auto reply.`]
                      },
                      {
                        columns: ['Type', 'URL']
                      },
                      {
                        columns: ['Example', `https://messageviewminio-staging.brightlink.com/lol/9d242251-7436-4fc5-9112-1907771d9f74.jpeg`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Suggested Replies List": {
          title: 'Suggested Replies List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Suggested Replies List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/prebuilt_replies`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/prebuilt_replies`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": [
                        {
                          "id": 129,
                          "keywords": [
                            "hi ",
                            "heelo"
                          ],
                          "title": "Suggested Reply",
                          "text_content": "Hi, How are you?"
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Suggested Replie Id.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '129']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Suggested Replie title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Suggested Reply`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['keywords', `Description`, `keyword for which suggested Reply works.`]
                      },
                      {
                        columns: ['Type', 'Array of String']
                      },
                      {
                        columns: ['Example', `[
                            "hi ",
                            "heelo"
                          ]`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['text_content', `Description`, `Suggested Reply Text content.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Hi, How are you?`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Template List": {
          title: 'Template List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Template List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/templates`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Templates.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/templates`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": [
                        {
                          "id": 23,
                          "title": "SMS Template",
                          "template_content": "Hey, This is My First Template.",
                          "media_data": {
                            "file": {
                              "name": "logo.jpg",
                              "size": 11438
                            },
                            "media": {
                              "media_file_mime": "image/jpeg",
                              "media_link": "https://messageviewminio-staging.brightlink.com/lol/0c5178b1-b5c4-4c49-a607-a885be6f18db.jpeg",
                              "media_minio_bucket_name": "lol",
                              "media_file_name": "logo.jpg"
                            }
                          }
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Template Id.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '23']
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Template title.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `SMS Template`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['text_content', `Description`, `Text Content mean text need to send in Template.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Hey, This is My First Template.`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['media_data', `Description`, `Media Data Object it contains information about the media.`]
                      },
                      {
                        columns: ['Type', 'Object']
                      },
                      {
                        columns: ['Example', `{
                            "file": {
                              "name": "logo.jpg",
                              "size": 11438
                            },
                            "media": {
                              "media_file_mime": "image/jpeg",
                              "media_link": "https://messageviewminio-staging.brightlink.com/lol/0c5178b1-b5c4-4c49-a607-a885be6f18db.jpeg",
                              "media_minio_bucket_name": "lol",
                              "media_file_name": "logo.jpg"
                            }
                          }`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Reporting": {
          title: 'Reporting',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Report for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/reports/tr/{from_date}/{to_date}/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['from_date', `Description`, `Select a From date from which you want to search report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2020-12-27']
                      },
                      {
                        rowSpan: 3,
                        columns: ['to_date', `Description`, `Select a  To date upto which you want to search a report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-01-27']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Report.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/reports/tr/2020-12-27/2021-01-27/14`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "data": {
                        "diagramData": [{ "total_count": "7", "inbound_count": "0", "outbound_count": "7", "sent_at_truncated_to_day": "2022-03-27T18:30:00.000Z" }, { "total_count": "6", "inbound_count": "3", "outbound_count": "3", "sent_at_truncated_to_day": "2022-03-28T18:30:00.000Z" }, { "total_count": "11", "inbound_count": "4", "outbound_count": "7", "sent_at_truncated_to_day": "2022-04-03T18:30:00.000Z" }], "top5InternalUsersOutboundData": [], "top5ExternalUsersOutboundData": [{ "external_contact_id": "2f6f5518-73fe-4abf-975c-4cacc9f8e530", "messages_count": "9", "first_name": "Chris", "last_name": "Verizon", "phone_number": "16785223503" }, { "external_contact_id": "2d924f67-6992-4fea-9648-1af9e575fee8", "messages_count": "6", "first_name": "James", "last_name": "Lansford", "phone_number": "12057907934" }, { "external_contact_id": "d7356bac-c2e6-4be7-a2ee-375c93cbed6e", "messages_count": "2", "first_name": "JoTo", "last_name": "Verizon", "phone_number": "17703107513" }], "top5ExternalUsersInboundData": [{ "external_contact_id": "e8087fad-dad2-4312-acfb-e5b7842d2683", "messages_count": "4", "first_name": "Stop", "last_name": "One", "phone_number": "12057907134" }, { "external_contact_id": "2d924f67-6992-4fea-9648-1af9e575fee8", "messages_count": "3", "first_name": "James", "last_name": "Lansford", "phone_number": "12057907934" }, { "external_contact_id": "2f6f5518-73fe-4abf-975c-4cacc9f8e530", "messages_count": "2", "first_name": "Chris", "last_name": "Verizon", "phone_number": "16785223503" }], "deliveredNotDeliveredData": { "delivered_count": 21, "not_delivered_count": 7, "total_inbound": 7, "total_outbound": 48 }, "top5InternalUsersInboundData": [], "sms_segmnent": 37, "blastReportData": [{ "name": "Test Blast", "sent_at_truncated_to_day": "2022-03-27T18:30:00.000Z", "delivered_count": "1", "rejected_count": "1", "total_count": "2" }, { "name": "New Blast", "sent_at_truncated_to_day": "2022-03-28T18:30:00.000Z", "delivered_count": "1", "rejected_count": "2", "total_count": "3" }, { "name": "Message Blast List", "sent_at_truncated_to_day": "2022-03-28T18:30:00.000Z", "delivered_count": "3", "rejected_count": "3", "total_count": "6" }], "stopMessageInboundData": [{ "total_count": "2", "sent_at_truncated_to_day": "2022-03-28T18:30:00.000Z" }, { "total_count": "2", "sent_at_truncated_to_day": "2022-04-03T18:30:00.000Z" }]
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Download Report": {
          title: 'Download Report',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for download Report for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/reports/csv_data/{from_date}/{to_date}/{phone_id}/{report_type}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['from_date', `Description`, `Select a From date from which you want to search report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2022-03-29']
                      },
                      {
                        rowSpan: 3,
                        columns: ['to_date', `Description`, `Select a  To date upto which you want to search a report. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2022-04-04']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Report.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      },
                      {
                        rowSpan: 3,
                        columns: ['report_type', `Description`, `Report Type is required. Valid Report are [MESSAGE_REPORT, BLAST_REPORT, STOP_REPORT]`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'MESSAGE_REPORT']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/reports/tr/2022-03-29/2022-04-04/14/MESSAGE_REPORT`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: { "data": [{ "from": "16785223503", "to": "18888714575", "text_content": "Got it", "name": "Chris Verizon", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-04-04T06:39:25.446Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "COOL", "name": "Chris Henn", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T06:38:36.647Z" }, { "from": "16785223503", "to": "18888714575", "text_content": "Got it", "name": "Chris Verizon", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-04-04T05:04:23.614Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "tESTING bRO", "name": "Chris Henn", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T05:02:20.929Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "ok", "name": "Chad Ryder", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T04:49:44.010Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "April 05, 2022", "name": "Chad Ryder", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T04:49:04.246Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "April 04, 2022", "name": "Chad Ryder", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T04:48:57.860Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "April, 04 2022 April, 05 2022", "name": "Chad Ryder", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T04:48:37.433Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "April, 04 2022 April, 05 2022", "name": "Chad Ryder", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-04-04T04:48:23.116Z" }, { "from": "12057907134", "to": "18888714575", "text_content": "sTop", "name": "Stop One", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-04-04T04:38:03.850Z" }, { "from": "12057907134", "to": "18888714575", "text_content": "Stop", "name": "Stop One", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-04-04T04:37:08.412Z" }, { "from": "12057907134", "to": "18888714575", "text_content": "STOP", "name": "Stop One", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-03-29T12:17:59.636Z" }, { "from": "18888714575", "to": "16785223503", "text_content": "STOP", "name": "Chad Ryder", "type": "OUTBOUND", "status": "SCCCESS", "sent_at_truncated_to_day": "2022-03-29T12:17:17.366Z" }, { "from": "12057907934", "to": "18888714575", "text_content": "STOP", "name": "James Lansford", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-03-29T12:16:00.081Z" }, { "from": "12057907934", "to": "18888714575", "text_content": "Hello F9.", "name": "James Lansford", "type": "INBOUND", "status": "SUCCESS", "sent_at_truncated_to_day": "2022-03-29T12:15:27.212Z" }] }
                  },
                ]
              }
            }
          ]
        },
        "Campaign ID": {
          title: 'Campaign ID',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Campaign ID for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone/campaign/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Report.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone/campaign/14`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: { "campaignId": "CASD12" }
                  },
                ]
              }
            }
          ]
        },
        "Advanced Search": {
          title: 'Advanced Search',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Advanced Search for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/messages_search/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Advanced Search.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/messages_search/14`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`start_date`, `Description`, `Select a Start date from which you want to search messages. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2020-12-27']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`end_date`, `Description`, `Select a End date upto which you want to search messages. Date format is YYYY-MM-DD.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '2021-01-27']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`search_str`, `Description`, `Message which you wants to search.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'got it']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "start_date": "2020-12-27",
                      "end_date": "2021-01-27",
                      "search_str": "got it"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "key": 1612742400000,
                        "key_as_string": "2021-02-08T00:00:00.000Z",
                        "doc_count": 2,
                        "top_hits_in_group": {
                          "hits": {
                            "total": {
                              "value": 2,
                              "relation": "eq"
                            },
                            "max_score": 15.421227,
                            "hits": [
                              {
                                "_index": "messages",
                                "_type": "message",
                                "_id": "baeAgncBoy8Rwu-naNdX",
                                "_score": 15.421227,
                                "_source": {
                                  "conversation_id": "1186ab2f-2700-4750-9d4b-104039db7821",
                                  "owner_phone_number": "14702029143",
                                  "from_phone_title": "15184171258",
                                  "to_phone_title": "14702029143",
                                  "message_id": 17410,
                                  "text_content": "Got got it",
                                  "created_at": "2021-02-08",
                                  "conv_type": "conversation"
                                }
                              },
                              {
                                "_index": "messages",
                                "_type": "message",
                                "_id": "7Kd8gncBoy8Rwu-nQdGp",
                                "_score": 12.531201,
                                "_source": {
                                  "conversation_id": "1186ab2f-2700-4750-9d4b-104039db7821",
                                  "owner_phone_number": "14702029143",
                                  "from_phone_title": "14702029143",
                                  "to_phone_title": "15184171258",
                                  "message_id": 17406,
                                  "text_content": "ok got",
                                  "created_at": "2021-02-08",
                                  "conv_type": "conversation"
                                }
                              }
                            ]
                          }
                        }
                      },
                      {
                        "key": 1611273600000,
                        "key_as_string": "2021-01-22T00:00:00.000Z",
                        "doc_count": 1,
                        "top_hits_in_group": {
                          "hits": {
                            "total": {
                              "value": 1,
                              "relation": "eq"
                            },
                            "max_score": 14.237457,
                            "hits": [
                              {
                                "_index": "messages",
                                "_type": "message",
                                "_id": "UTAUKXcBoy8Rwu-nnYRj",
                                "_score": 14.237457,
                                "_source": {
                                  "conversation_id": "1186ab2f-2700-4750-9d4b-104039db7821",
                                  "owner_phone_number": "14702029143",
                                  "from_phone_title": "15184171258",
                                  "to_phone_title": "14702029143",
                                  "message_id": 17396,
                                  "text_content": "Got it",
                                  "created_at": "2021-01-22",
                                  "conv_type": "conversation"
                                }
                              }
                            ]
                          }
                        }
                      }
                    ]
                  },
                ]
              }
            }
          ]
        },
        "Conversation List": {
          title: 'Conversation List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Conversation List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user_message/conversations/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Conversation List.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user_message/conversations/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "id": "f42b668e-4a97-4309-855d-0ed1cf315abb",
                        "last_message": "2021-02-09T05:23:08.477Z",
                        "type": "conversation",
                        "name": "Jack"
                      }
                    ]
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Conversation Id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'f42b668e-4a97-4309-855d-0ed1cf315abb']
                      },
                      {
                        rowSpan: 3,
                        columns: ['last_message', `Description`, `Conversation Time for Last Message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `2021-02-09T05:23:08.477Z`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Name of the Conversation.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Jack`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Blast Conversation List": {
          title: 'Blast Conversation List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Blast Conversation List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user_blast/conversations/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Blast Conversation List.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 14]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user_blast/conversations/14`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "id": "4751c987-88e9-46c3-aa9f-f0ff4c76c973",
                        "name": "Blast_3",
                        "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                        "type": "blast",
                        "last_message": "2021-02-02T15:48:08.615Z"
                      },
                      {
                        "id": "6ba37d80-8c00-4801-b2bc-23d19d899ea3",
                        "name": "New Test List",
                        "compliance": "Message and data rates may apply.\nReply 'STOP' if you no longer want to receive messages or 'HELP' for more options.",
                        "type": "blast",
                        "last_message": false
                      }
                    ]
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Blast Conversation Id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4751c987-88e9-46c3-aa9f-f0ff4c76c973']
                      },
                      {
                        rowSpan: 3,
                        columns: ['last_message', `Description`, `Conversation Time for Last Message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `2021-02-02T15:48:08.615Z`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['name', `Description`, `Name of the Blast Conversation.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Blast_3`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['compliance', `Description`, `compliance message for Blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Message and data rates may apply.\nReply 'STOP' if you no longer want to receive messages or 'HELP' for more options.`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Conversation Messages": {
          title: 'Conversation Messages',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Conversation Messages for a given Conversation Id, Phone Number. you can select only those Conversation Id which is assigned to Phone Number.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation assigned to the Phone Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/conversation_message/{conversation_id}/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['conversation_id', `Description`, `Conversation ID is required for fetching Conversation Messages.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '3547aa18-4c79-4da6-95ed-1fddedd1ca55']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Conversation Messages for a given Conversation ID.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/conversation_message/3547aa18-4c79-4da6-95ed-1fddedd1ca55/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "user_phone_number": "18032918428",
                      "active_conversation_phone_number": "18287845279",
                      "messages": [
                        {
                          "id": 146578,
                          "text_content": "Hello",
                          "sent_at": "2021-02-09T07:22:39.342Z",
                          "sender_id": "b1df2124-3f5b-4564-8b2d-75c0ae7e1599",
                          "message_type": "message",
                          "sender": {
                            "first_name": "Tri",
                            "last_name": "Phan",
                            "phone_number": "14043341185",
                            "internal": true
                          },
                          "type": "OUTBOUND"
                        }
                      ],
                      "data": {
                        "OUTBOUND": [
                          {
                            "id": 146578,
                            "text_content": "Hello",
                            "sent_at": "2021-02-09T07:22:39.342Z",
                            "sender_id": "b1df2124-3f5b-4564-8b2d-75c0ae7e1599",
                            "message_type": "message",
                            "sender": {
                              "first_name": "Tri",
                              "last_name": "Phan",
                              "phone_number": "14043341185",
                              "internal": true
                            },
                            "type": "OUTBOUND"
                          }
                        ]
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`user_phone_number`, `Description`, `Active Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '18032918428']
                      },
                      {
                        rowSpan: 3,
                        columns: ['active_conversation_phone_number', `Description`, `Active Conversation Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `18287845279`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['type', `Description`, `Type determines that the message type is INBOUND/OUTBOUND.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `OUTBOUND`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['text_content', `Description`, `Send Message Content.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Hello`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Blast Messages": {
          title: 'Blast Messages',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Blast Messages for a given Blast Id. you can select only those Blast Id which is assigned to Phone Number.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Blast assigned to the Phone Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/blast_messages/{blast_id}/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['blast_id', `Description`, `Blast ID is required for fetching Blast Messages.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4751c987-88e9-46c3-aa9f-f0ff4c76c973']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Blast Messages for a given Blast ID.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/blast_messages/4751c987-88e9-46c3-aa9f-f0ff4c76c973/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": "4751c987-88e9-46c3-aa9f-f0ff4c76c973",
                      "name": "Blast_3",
                      "notes": "",
                      "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                      "receive_compliance": [
                        "12292554209",
                        "14844732556",
                        "17039440593"
                      ],
                      "stopped": [],
                      "is_deleted": false,
                      "created": "2021-02-01T17:51:41.361Z",
                      "csv_filename": "",
                      "sent_at": "2021-02-02T15:48:08.615Z",
                      "internal": [
                        {
                          "id": 14,
                          "phone_number": "14043341185",
                          "title": "Tri Phan",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2019-07-16T09:19:27.938Z",
                          "rateOfSend": 1
                        }
                      ],
                      "external": [
                        {
                          "id": 345627,
                          "title": "Jessica Thornhill-M",
                          "phone_number": "12292554209"
                        },
                        {
                          "id": 345628,
                          "title": "Tri Staging",
                          "phone_number": "14844732556"
                        },
                        {
                          "id": 345629,
                          "title": "Nabeel Saleheen",
                          "phone_number": "17039440593"
                        }
                      ],
                      "messages": [
                        {
                          "id": 146563,
                          "sender_type": "user",
                          "sender_id": "b1df2124-3f5b-4564-8b2d-75c0ae7e1599",
                          "text_content": "Msg2",
                          "message_type": "message",
                          "media_link": null,
                          "media_file_name": null,
                          "media_file_mime": "",
                          "media_minio_bucket_name": null,
                          "ready_to_be_sent": false,
                          "media_type": null,
                          "sender_phone_number": "14043341185",
                          "sent_at": "2021-02-01T17:52:10.698Z",
                          "delivery_status": 0,
                          "delivered_at": null,
                          "sender": {
                            "username": "Tri",
                            "display_as": "Tri Phan",
                            "last_name": "Phan",
                            "first_name": "Tri",
                            "internal": true
                          }
                        },
                        {
                          "id": 146564,
                          "sender_type": "user",
                          "sender_id": "b1df2124-3f5b-4564-8b2d-75c0ae7e1599",
                          "text_content": "[compliance] Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                          "message_type": "message",
                          "media_link": null,
                          "media_file_name": null,
                          "media_file_mime": "",
                          "media_minio_bucket_name": null,
                          "ready_to_be_sent": false,
                          "media_type": null,
                          "sender_phone_number": "14043341185",
                          "sent_at": "2021-02-01T17:52:10.698Z",
                          "delivery_status": 0,
                          "delivered_at": null,
                          "sender": {
                            "username": "Tri",
                            "display_as": "Tri Phan",
                            "last_name": "Phan",
                            "first_name": "Tri",
                            "internal": true
                          }
                        },
                        {
                          "id": 146570,
                          "sender_type": "user",
                          "sender_id": "b1df2124-3f5b-4564-8b2d-75c0ae7e1599",
                          "text_content": "blast message",
                          "message_type": "message",
                          "media_link": null,
                          "media_file_name": null,
                          "media_file_mime": "",
                          "media_minio_bucket_name": null,
                          "ready_to_be_sent": false,
                          "media_type": null,
                          "sender_phone_number": "14043341185",
                          "sent_at": "2021-02-02T15:48:08.615Z",
                          "delivery_status": 0,
                          "delivered_at": null,
                          "sender": {
                            "username": "Tri",
                            "display_as": "Tri Phan",
                            "last_name": "Phan",
                            "first_name": "Tri",
                            "internal": true
                          }
                        }
                      ],
                      "type": "blast"
                    }
                  },
                ]
              }
            }
          ]
        },
        "Download Conversation Messages": {
          title: 'Download Conversation Messages',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Download Conversation Messages for a given Conversation Id, Phone Number. you can select only those Conversation Id which is assigned to Phone Number.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation assigned to the Phone Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/csv_data/conversation_message/{conversation_id}/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['conversation_id', `Description`, `Conversation ID is required for fetching Download Conversation Messages.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '3547aa18-4c79-4da6-95ed-1fddedd1ca55']
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching Download Conversation Messages for a given Conversation ID.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/csv_data/conversation_message/3547aa18-4c79-4da6-95ed-1fddedd1ca55/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "user_phone_number": "18032918428",
                      "active_conversation_phone_number": "18287845279",
                      "messages": [
                        {
                          "time_stamp": "02/09/2021 12:52:39 PM",
                          "from": "18032918428",
                          "to": "18287845279",
                          "user_name": "Tri Phan",
                          "message": "Hello"
                        }
                      ]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`user_phone_number`, `Description`, `Active Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '18032918428']
                      },
                      {
                        rowSpan: 3,
                        columns: ['active_conversation_phone_number', `Description`, `Active Conversation Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `18287845279`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['message', `Description`, `Message Content.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Hello`]
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "External Contact List": {
          title: 'External Contact List',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching External Contact List for a given Phone Number. you can select only those Phone Number which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/external_contacts/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for fetching External Contact Details.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/external_contacts/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "id": "778c9c8c-c68d-40e0-8bdc-91a39e1dd076",
                        "phone_number": "18287845279",
                        "notes": "",
                        "in_contacts": true,
                        "is_deleted": null,
                        "company": "",
                        "job_title": "",
                        "email": "",
                        "address_line_1": "",
                        "address_line_2": "",
                        "city": "",
                        "state": "",
                        "zipcode": "",
                        "custom_field_1": "",
                        "custom_field_2": "",
                        "custom_field_3": "",
                        "title": "Jack Richer"
                      },
                      {
                        "id": "49dc7132-ee2d-44ae-9e1d-c6940502f92a",
                        "phone_number": "18888882222",
                        "notes": "",
                        "in_contacts": true,
                        "is_deleted": false,
                        "company": "",
                        "job_title": "",
                        "email": "",
                        "address_line_1": "",
                        "address_line_2": "",
                        "city": "",
                        "state": "",
                        "zipcode": "",
                        "custom_field_1": "",
                        "custom_field_2": "",
                        "custom_field_3": "",
                        "title": "f1 tEST"
                      }
                    ]
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['id', `Description`, `Its unique Id for the External Contact.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', `778c9c8c-c68d-40e0-8bdc-91a39e1dd076`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['title', `Description`, `Title is a  combined of first name and last name of External Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `Jack Richer`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['phone_number', `Description`, `Phone Number.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '18287845279']
                      }
                    ]
                  }
                ]
              }
            }
          ]
        },
        "Scheduled Message": {
          title: 'Scheduled Message',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for fetching Scheduled Message for a given Conversation Id. you can select only those Conversation Id which is assigned to Phone Number.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation assigned to the Phone Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/schedule_message/{conversation_id}`]
                      },
                      {
                        columns: ['Method:', 'GET']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['conversation_id', `Description`, `Conversation ID is required for fetching Scheduled Messages.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'ed0c7623-1e3c-4507-82f0-67e94cfaa543']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/schedule_message/ed0c7623-1e3c-4507-82f0-67e94cfaa543`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: [
                      {
                        "id": 129,
                        "message_content": "First Recurring Message!!",
                        "schedule_at": null,
                        "type": 1,
                        "recurring_schedule_message": [
                          {
                            "dayName": "Monday",
                            "isActive": true,
                            "timeFrom": "18:00:30"
                          },
                          {
                            "dayName": "Tuesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Wednesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Thursday",
                            "isActive": true,
                            "timeFrom": "18:00:30"
                          },
                          {
                            "dayName": "Friday",
                            "isActive": false
                          },
                          {
                            "dayName": "Saturday",
                            "isActive": false
                          },
                          {
                            "dayName": "Sunday",
                            "isActive": false
                          }
                        ],
                        "media_data": null,
                        "user": {
                          "first_name": "Nitesh",
                          "last_name": "Axxess",
                          "username": "Nitesh",
                          "password_changed_at": "2021-06-28T11:47:49.947Z",
                          "passwords": [],
                          "isPasswordExpired": false
                        }
                      },
                      {
                        "id": 128,
                        "message_content": "This was the First ScheduleMessage",
                        "schedule_at": "2021-07-29T11:22:40.000Z",
                        "type": 0,
                        "recurring_schedule_message": [
                          {
                            "dayName": "Monday",
                            "isActive": false
                          },
                          {
                            "dayName": "Tuesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Wednesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Thursday",
                            "isActive": false
                          },
                          {
                            "dayName": "Friday",
                            "isActive": false
                          },
                          {
                            "dayName": "Saturday",
                            "isActive": false
                          },
                          {
                            "dayName": "Sunday",
                            "isActive": false
                          }
                        ],
                        "media_data": {
                          "file": {
                            "name": "logo1.jpg",
                            "size": 11438
                          },
                          "media": {
                            "media_file_mime": "image/jpeg",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/72eb712f-c832-473f-9d87-d0746b2efba4.jpeg",
                            "media_minio_bucket_name": "lol"
                          }
                        },
                        "user": {
                          "first_name": "Nitesh",
                          "last_name": "Axxess",
                          "username": "Nitesh",
                          "password_changed_at": "2021-06-28T11:47:49.947Z",
                          "passwords": [],
                          "isPasswordExpired": false
                        }
                      }
                    ]
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`id`, `Description`, `Schedule Message Id.`]
                      },
                      {
                        columns: ['Type', 'Long']
                      },
                      {
                        columns: ['Example', '129']
                      },
                      {
                        rowSpan: 3,
                        columns: ['message_content', `Description`, `Schedule Message content.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `This was the First ScheduleMessage`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['schedule_at', `Description`, `Time for Schedule Message its must be an UTC timezone.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', `2021-07-29T11:22:40.000Z`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['type', `Description`, `Type 0 for Scheuled Message and 1 for Recurring Message.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', `0`]
                      },
                      {
                        rowSpan: 3,
                        columns: ['recurring_schedule_message', `Description`, `Its a Scheduled time for Recurring Message.`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `[
                          {
                            "dayName": "Monday",
                            "isActive": false
                          },
                          {
                            "dayName": "Tuesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Wednesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Thursday",
                            "isActive": false
                          },
                          {
                            "dayName": "Friday",
                            "isActive": false
                          },
                          {
                            "dayName": "Saturday",
                            "isActive": false
                          },
                          {
                            "dayName": "Sunday",
                            "isActive": false
                          }
                        ]`
                        ]
                      },
                      {
                        rowSpan: 3,
                        columns: ['media_data', `Description`, `It contains information about Media.`]
                      },
                      {
                        columns: ['Type', 'JSON Object']
                      },
                      {
                        columns: ['Type', `{
                                              "file": {
                                                  "name": "logo1.jpg",
                                                  "size": 11438
                                              },
                                              "media": {
                                                  "media_file_mime": "image/jpeg",
                                                  "media_link": "https://messageviewminio-staging.brightlink.com/lol/72eb712f-c832-473f-9d87-d0746b2efba4.jpeg",
                                                  "media_minio_bucket_name": "lol"
                                              }
                                          }`
                        ]
                      },
                    ]
                  }
                ]
              }
            }
          ]
        },
      }
    },
    Write: {
      chlidLinks: {
        "Create Contact": {
          title: 'Create Contact',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Contact for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/external_contacts/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Contact.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 432]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/external_contacts/432`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`first_name`, `Description`, `First Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Jack']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`last_name`, `Description`, `Last Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Richer']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`phone_number`, `Description`, `Phone Number must be 10 digit.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '8882918576']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`company`, `Description`, `Company Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'BB Test']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`job_title`, `Description`, `Job Title of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'SE']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `Email of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'jack@bb.com']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`address_line_1`, `Description`, `Address 1 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Address 1']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`address_line_2`, `Description`, `Address 2 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Address 2']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`city`, `Description`, `City of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CI']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`state`, `Description`, `State of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'ST']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`zipcode`, `Description`, `Zipcode of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '206110']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`custom_field_1`, `Description`, `Custom Field 1 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CF1']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`custom_field_2`, `Description`, `Custom Field 2 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CF2']
                      },
                      {
                        columns: ['Required', 'No']
                      }, {
                        rowSpan: 4,
                        columns: [`custom_field_3`, `Description`, `Custom Field 3 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CF3']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`notes`, `Description`, `Notes of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'I am Richer.']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "first_name": "Jack",
                      "last_name": "Richer",
                      "phone_number": "8882918576",
                      "company": "BB Test",
                      "job_title": "SE",
                      "email": "jack@bb.com",
                      "address_line_1": "Address 1",
                      "address_line_2": "Address 2",
                      "city": "CI",
                      "state": "ST",
                      "zipcode": "206110",
                      "custom_field_1": "CF1",
                      "custom_field_2": "CF2",
                      "custom_field_3": "CF3",
                      "notes": "I am Richer.",
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": "458a6394-d24f-4476-ad92-880cb43339d4",
                      "first_name": "Jack",
                      "last_name": "Richer",
                      "notes": "I am Richer.",
                      "phone_number": "18882918576",
                      "company": "BB Test",
                      "job_title": "SE",
                      "email": "jack@bb.com",
                      "address_line_1": "Address 1",
                      "address_line_2": "Address 2",
                      "city": "CI",
                      "state": "ST",
                      "zipcode": "206110",
                      "custom_field_1": "CF1",
                      "custom_field_2": "CF2",
                      "custom_field_3": "CF3",
                      "in_contacts": true,
                      "deleted": false,
                      "is_deleted": false,
                      "phone_owner": {
                        "id": 432,
                        "phone_number": "19859001376",
                        "title": "19859001376",
                        "timezone": "America/New_York",
                        "is_deleted": false,
                        "created_at": "2020-06-01T13:30:05.367Z",
                        "rateOfSend": 1,
                        "company": {
                          "id": 117,
                          "name": "Axxess Networks",
                          "subdomain": "AxxessNetworks",
                          "status": 1,
                          "created_at": "2020-06-01T13:29:25.630Z",
                          "active_at": "2020-06-01T13:29:25.630Z",
                          "owner": "a8266af2-e3a9-430e-8a8f-6aa9b9453c2e",
                          "reseller": "67dd91b3-3824-438b-870d-c71a532b1b5b",
                          "disabled": false
                        }
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Update Contact": {
          title: 'Update Contact',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Existing Contact for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user. Extrenal Contact Id is required for Update.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#14`, detail: 'Click here to Get List of External contact Id assigned to the Phone Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/external_contacts/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Contact.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 432]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/external_contacts/432`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "PUT Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`id`, `Description`, `External Contact id For Update.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Jack']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`first_name`, `Description`, `First Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Jack']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`last_name`, `Description`, `Last Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Ray']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`phone_number`, `Description`, `Phone Number must be 10 digit.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '8882918576']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`company`, `Description`, `Company Name of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'BB Test']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`job_title`, `Description`, `Job Title of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'SE']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`email`, `Description`, `Email of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'jack@bb.com']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`address_line_1`, `Description`, `Address 1 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Address 1']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`address_line_2`, `Description`, `Address 2 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Address 2']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`city`, `Description`, `City of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CI']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`state`, `Description`, `State of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'ST']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`zipcode`, `Description`, `Zipcode of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '206110']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`custom_field_1`, `Description`, `Custom Field 1 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CF1']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`custom_field_2`, `Description`, `Custom Field 2 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CF2']
                      },
                      {
                        columns: ['Required', 'No']
                      }, {
                        rowSpan: 4,
                        columns: [`custom_field_3`, `Description`, `Custom Field 3 of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'CF3']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`notes`, `Description`, `Notes of the Contact.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'I am Richer.']
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": "458a6394-d24f-4476-ad92-880cb43339d4",
                      "first_name": "Jack",
                      "last_name": "Ray",
                      "notes": "I am Richer.",
                      "phone_number": "18882918576",
                      "company": "BB Test",
                      "job_title": "SE",
                      "email": "jack@bb.com",
                      "address_line_1": "Address 1",
                      "address_line_2": "Address 1",
                      "city": "CI",
                      "state": "ST",
                      "zipcode": "206110",
                      "custom_field_1": "CF1",
                      "custom_field_2": "CF2",
                      "custom_field_3": "CF3"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": "458a6394-d24f-4476-ad92-880cb43339d4",
                      "first_name": "Jack",
                      "last_name": "Ray",
                      "phone_number": "18882918576",
                      "notes": "I am Richer.",
                      "in_contacts": true,
                      "is_deleted": false,
                      "company": "BB Test",
                      "job_title": "SE",
                      "email": "jack@bb.com",
                      "address_line_1": "Address 1",
                      "address_line_2": "Address 1",
                      "city": "CI",
                      "state": "ST",
                      "zipcode": "206110",
                      "custom_field_1": "CF1",
                      "custom_field_2": "CF2",
                      "custom_field_3": "CF3"
                    }
                  },
                ]
              }
            }
          ]
        },
        "Create Blast": {
          title: 'Create Blast',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Blast for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#14`, detail: 'Click here to Get List of External Contact Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/blast/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Blast.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/external_contacts/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`compliance`, `Description`, `Compliance Message for a Blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Message and data rates may apply.\nReply STOP to end or HELP for more options.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`name`, `Description`, `Name of the Blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Custom Blast']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`notes`, `Description`, `Blast Notes.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'My Notes']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`external`, `Description`, `External Contact Ids must be valid otherwise Blast does not create. you can use above link to get External Contact Ids List.`]
                      },
                      {
                        columns: ['Type', 'Array of External Contact Id']
                      },
                      {
                        columns: ['Example', `["458a6394-d24f-4476-ad92-880cb43339d4","49dc7132-ee2d-44ae-9e1d-c6940502f92a"]`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                      "name": "MY Blast",
                      "notes": "My Notes",
                      "external": ["458a6394-d24f-4476-ad92-880cb43339d4", "49dc7132-ee2d-44ae-9e1d-c6940502f92a"]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "id": "dccefa02-3c9f-4e3c-bcff-15bebcb8cc65",
                        "name": "MY Blast",
                        "notes": "My Notes",
                        "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                        "internal": {
                          "id": 251,
                          "phone_number": "19859001376",
                          "title": "19859001376",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2020-06-01T13:30:05.367Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 117,
                            "name": "Test Networks",
                            "subdomain": "TestNetworks",
                            "status": 1,
                            "created_at": "2020-06-01T13:29:25.630Z",
                            "active_at": "2020-06-01T13:29:25.630Z",
                            "owner": "a8266af2-e3a9-430e-8a8f-6aa9b9453c2e",
                            "reseller": "67dd91b3-3824-438b-870d-c71a532b1b5b",
                            "disabled": false
                          }
                        },
                        "receive_compliance": [],
                        "stopped": [],
                        "csv_filename": "",
                        "sent_at": null,
                        "is_deleted": false,
                        "created": "2021-06-30T04:47:16.904Z",
                        "external": [
                          {
                            "id": 345708,
                            "title": "f1 tEST",
                            "phone_number": "18888882222",
                            "company": "",
                            "job_title": "",
                            "email": "",
                            "address_line_1": "",
                            "address_line_2": "",
                            "city": "",
                            "state": "",
                            "zipcode": "",
                            "custom_field_1": "",
                            "custom_field_2": "",
                            "custom_field_3": ""
                          },
                          {
                            "id": 345709,
                            "title": "Jack Ray",
                            "phone_number": "18882918576",
                            "company": "BB Test",
                            "job_title": "SE",
                            "email": "jack@bb.com",
                            "address_line_1": "Address 1",
                            "address_line_2": "Address 1",
                            "city": "CI",
                            "state": "ST",
                            "zipcode": "206110",
                            "custom_field_1": "CF1",
                            "custom_field_2": "CF2",
                            "custom_field_3": "CF3"
                          }
                        ]
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Update Blast": {
          title: 'Update Blast',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Blast for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#3`, detail: 'Click here to Get List of Blast Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/user/blast/{phone_id}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Update Blast.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/user/external_contacts/251`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`id`, `Description`, `Blast Id for Update.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'dccefa02-3c9f-4e3c-bcff-15bebcb8cc65']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`compliance`, `Description`, `Compliance Message for a Blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Message and data rates may apply.\nReply STOP to end or HELP for more options.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`name`, `Description`, `Name of the Blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Custom Blast']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`notes`, `Description`, `Blast Notes.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'My Notes']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`external`, `Description`, `External Contact Ids must be valid otherwise Blast does not create. you can use above link to get External Contact Ids List.`]
                      },
                      {
                        columns: ['Type', 'Array of External Contact Id']
                      },
                      {
                        columns: ['Example', `["458a6394-d24f-4476-ad92-880cb43339d4"]`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": "dccefa02-3c9f-4e3c-bcff-15bebcb8cc65",
                      "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                      "name": "Update Blast1",
                      "notes": "Update Notes",
                      "external": ["458a6394-d24f-4476-ad92-880cb43339d4"]
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "data": {
                        "id": "dccefa02-3c9f-4e3c-bcff-15bebcb8cc65",
                        "name": "Update Blast1",
                        "notes": "Update Notes",
                        "compliance": "Message and data rates may apply.\nReply STOP to end or HELP for more options.",
                        "receive_compliance": [
                          "18888882222",
                          "18882918576"
                        ],
                        "stopped": [],
                        "is_deleted": false,
                        "created": "2021-06-30T04:47:16.904Z",
                        "csv_filename": "",
                        "sent_at": "2021-06-30T04:49:30.393Z",
                        "internal": {
                          "id": 251,
                          "phone_number": "19859001376",
                          "title": "19859001376",
                          "timezone": "America/New_York",
                          "is_deleted": false,
                          "created_at": "2020-06-01T13:30:05.367Z",
                          "rateOfSend": 1,
                          "company": {
                            "id": 117,
                            "name": "Test Networks",
                            "subdomain": "TestNetworks",
                            "status": 1,
                            "created_at": "2020-06-01T13:29:25.630Z",
                            "active_at": "2020-06-01T13:29:25.630Z",
                            "owner": "a8266af2-e3a9-430e-8a8f-6aa9b9453c2e",
                            "reseller": "67dd91b3-3824-438b-870d-c71a532b1b5b",
                            "disabled": false
                          }
                        },
                        "external": [
                          {
                            "id": 345716,
                            "title": "Jack Ray",
                            "phone_number": "18882918576",
                            "company": "BB Test",
                            "job_title": "SE",
                            "email": "jack@bb.com",
                            "address_line_1": "Address 1",
                            "address_line_2": "Address 1",
                            "city": "CI",
                            "state": "ST",
                            "zipcode": "206110",
                            "custom_field_1": "CF1",
                            "custom_field_2": "CF2",
                            "custom_field_3": "CF3"
                          }
                        ]
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Create Suggested Replies": {
          title: 'Create Suggested Replies',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Suggested Replies for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/prebuilt_replies`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/prebuilt_replies`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title for a Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hi']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`keywords`, `Description`, `keywords for a Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'Array of String']
                      },
                      {
                        columns: ['Example', `[
                          "hi",
                          "hello"
                      ]`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`text_content`, `Description`, `Suggested Reply.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hi, How are you?']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "title": "Hi",
                      "keywords": [
                        "hi",
                        "hello"
                      ],
                      "text_content": "Hi, How are you?"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 132
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Update Suggested Replies": {
          title: 'Update Suggested Replies',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Suggested Replies for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#5`, detail: 'Click here to Get List of Suggested Replie Id assigned to the Phone Number.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/prebuilt_replies/{pr_id}`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: ['phone_id', `Description`, `Phone ID is required for Update Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['pr_id', `Description`, `Suggested Reply ID is required to Update Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 132]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/prebuilt_replies/132`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "PUT Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title for a Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hi']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`keywords`, `Description`, `keywords for a Suggested Replies.`]
                      },
                      {
                        columns: ['Type', 'Array of String']
                      },
                      {
                        columns: ['Example', `[
                          "hi",
                          "hello"
                      ]`]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`text_content`, `Description`, `Suggested Reply.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Hi, How are you?']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "title": "Hi",
                      "keywords": [
                        "hi",
                        "hello"
                      ],
                      "text_content": "Hi, How are you?"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 132
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Create Template": {
          title: 'Create Template',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Template for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Write#14`, detail: 'Click here to save and generate media data object.' },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/template`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Template.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/template`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title for a Template.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Create Template']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`template_content`, `Description`, `Content for Template.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Demo For Create Template.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`media_data`, `Description`, `Media Data for save Media, you can create media data object by clicking on create media link.`]
                      },
                      {
                        columns: ['Type', 'Object of Media Data']
                      },
                      {
                        columns: ['Example', `{
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }`]
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "title": "Create Template",
                      "template_content": "Demo For Create Template.",
                      "media_data": {
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 26,
                        "title": "Create Template",
                        "template_content": "Demo For Create Template.",
                        "media_data": {
                          "file": {
                            "name": "logo.jpg",
                            "size": 11438
                          },
                          "media": {
                            "media_file_mime": "image/jpeg",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                            "media_minio_bucket_name": "lol",
                            "media_file_name": "logo.jpg"
                          }
                        }
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Update Template": {
          title: 'Update Template',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Template for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Write#14`, detail: 'Click here to save and generate media data object.' },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/template/{template_id}`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Template.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: ['template_id', `Description`, `Template ID is required for Update Template.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 26]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/template/26`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "PUT Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`title`, `Description`, `Title for a Template.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Update Template']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`template_content`, `Description`, `Content for Template.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Demo For Update Template.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`media_data`, `Description`, `Media Data for save Media, you can create media data object by clicking on create media link.`]
                      },
                      {
                        columns: ['Type', 'Object of Media Data']
                      },
                      {
                        columns: ['Example', `{
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }`]
                      },
                      {
                        columns: ['Required', 'No']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "title": "Update Template",
                      "template_content": "Demo For Update Template.",
                      "media_data": {
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 26
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
        "Create Scheduled Message": {
          title: 'Create Scheduled Message',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Scheduled Message for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Write#14`, detail: 'Click here to save and generate media data object.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation Id.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#10`, detail: 'Click here to Get List of Blast Conversation Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/schedule_message`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Schedule Message.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/schedule_message`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`message_content`, `Description`, `Message Content for a Scheduled Message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Create Schedule Via API.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`schedule_at`, `Description`, `Schedule Message time, it must be in UTC Format.`]
                      },
                      {
                        columns: ['Type', 'Datetime']
                      },
                      {
                        columns: ['Example', '2021-07-29T13:25:19.000Z']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`media_data`, `Description`, `Media Data for save Media, you can create media data object by clicking on create media link.`]
                      },
                      {
                        columns: ['Type', 'Object of Media Data']
                      },
                      {
                        columns: ['Example', `{
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }`]
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_type`, `Description`, `Conversation Type must be either conversation or blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'conversation']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_id`, `Description`, `we need to put conversation_id if the Conversation Type is conversation than we need to select valid conversation id, if the Conversation Type is blast than we need to select valid blast id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'ed0c7623-1e3c-4507-82f0-67e94cfaa543']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`is_past`, `Description`, `Is Past mean if we want to skip schedule message than we need to make is_past true.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'false']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "schedule_at": "2021-07-29T13:25:19.000Z",
                      "message_content": "Create Schedule Via API.",
                      "media_data": {
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                          "media_minio_bucket_name": "lol"
                        }
                      },
                      "is_past": false,
                      "conversation_type": "conversation",
                      "conversation_id": "ed0c7623-1e3c-4507-82f0-67e94cfaa543"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 143,
                        "message_content": "Create Schedule Via API.",
                        "schedule_at": "2021-07-29T13:25:19.000Z",
                        "conversation_type": "conversation",
                        "conversation_id": "ed0c7623-1e3c-4507-82f0-67e94cfaa543",
                        "media_data": {
                          "file": {
                            "name": "logo.jpg",
                            "size": 11438
                          },
                          "media": {
                            "media_file_mime": "image/jpeg",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                            "media_minio_bucket_name": "lol"
                          }
                        }
                      }
                    }
                  }
                ]
              }
            }
          ]
        },
        "Update Scheduled Message": {
          title: 'Update Scheduled Message',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Scheduled Message for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#15`, detail: 'Click here to Get List of valid Scheduled Message Id.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Write#14`, detail: 'Click here to save and generate media data object.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation Id.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#10`, detail: 'Click here to Get List of Blast Conversation Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/schedule_message`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Schedule Message.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/schedule_message`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`id`, `Description`, `Valid Scheduled Message Id for update.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '143']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`message_content`, `Description`, `Message Content for a Scheduled Message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Create Schedule Via API.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`schedule_at`, `Description`, `Schedule Message time, it must be in UTC Format.`]
                      },
                      {
                        columns: ['Type', 'Datetime']
                      },
                      {
                        columns: ['Example', '2021-07-29T13:25:19.000Z']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`media_data`, `Description`, `Media Data for save Media, you can create media data object by clicking on create media link.`]
                      },
                      {
                        columns: ['Type', 'Object of Media Data']
                      },
                      {
                        columns: ['Example', `{
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }`]
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_type`, `Description`, `Conversation Type must be either conversation or blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'conversation']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_id`, `Description`, `we need to put conversation_id if the Conversation Type is conversation than we need to select valid conversation id, if the Conversation Type is blast than we need to select valid blast id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'ed0c7623-1e3c-4507-82f0-67e94cfaa543']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`is_past`, `Description`, `Is Past mean if we want to skip schedule message than we need to make is_past true.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'false']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": 143,
                      "schedule_at": "2021-07-29T13:25:19.000Z",
                      "message_content": "Create Schedule Via API.",
                      "media_data": {
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                          "media_minio_bucket_name": "lol"
                        }
                      },
                      "is_past": false,
                      "conversation_type": "conversation",
                      "conversation_id": "ed0c7623-1e3c-4507-82f0-67e94cfaa543"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 143,
                        "message_content": "Create Schedule Via API.",
                        "schedule_at": "2021-07-29T13:25:19.000Z",
                        "conversation_type": "conversation",
                        "conversation_id": "ed0c7623-1e3c-4507-82f0-67e94cfaa543",
                        "media_data": {
                          "file": {
                            "name": "logo.jpg",
                            "size": 11438
                          },
                          "media": {
                            "media_file_mime": "image/jpeg",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                            "media_minio_bucket_name": "lol"
                          }
                        }
                      }
                    }
                  }
                ]
              }
            }
          ]
        },
        "Create Recurring Message": {
          title: 'Create Recurring Message',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Create Recurring Message for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Write#14`, detail: 'Click here to save and generate media data object.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation Id.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#10`, detail: 'Click here to Get List of Blast Conversation Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/recurring_message`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Schedule Message.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/recurring_message`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`message_content`, `Description`, `Message Content for a Scheduled Message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Create Recurring Schedule Via API.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`recurring_schedule_message`, `Description`, `Array of Recurring Schedule Message must be valid. timeFrom must be in UTC 24HR format`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `
                        [
                          {
                              "isActive": true,
                              "dayName": "Monday",
                              "timeFrom": "11:25:22"
                          },
                          {
                              "isActive": false,
                              "dayName": "Tuesday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Wednesday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Thursday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Friday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Saturday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Sunday"
                          }
                        ]
                      `]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`media_data`, `Description`, `Media Data for save Media, you can create media data object by clicking on create media link.`]
                      },
                      {
                        columns: ['Type', 'Object of Media Data']
                      },
                      {
                        columns: ['Example', `{
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }`]
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_type`, `Description`, `Conversation Type must be either conversation or blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'conversation']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_id`, `Description`, `we need to put conversation_id if the Conversation Type is conversation than we need to select valid conversation id, if the Conversation Type is blast than we need to select valid blast id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'ed0c7623-1e3c-4507-82f0-67e94cfaa543']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`is_past`, `Description`, `Is Past mean if we want to skip schedule message than we need to make is_past true.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'false']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "message_content": "Create Recurring Schedule Via API.",
                      "recurring_schedule_message": [
                        {
                          "isActive": true,
                          "dayName": "Monday",
                          "timeFrom": "11:25:22"
                        },
                        {
                          "isActive": false,
                          "dayName": "Tuesday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Wednesday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Thursday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Friday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Saturday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Sunday"
                        }
                      ],
                      "media_data": {
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                          "media_minio_bucket_name": "lol"
                        }
                      },
                      "is_past": false,
                      "conversation_type": "blast",
                      "conversation_id": "fa73701f-2e0f-44dd-a483-389091cd1aab"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 151,
                        "message_content": "Create Recurring Schedule Via API.",
                        "recurring_schedule_message": [
                          {
                            "dayName": "Monday",
                            "isActive": true,
                            "timeFrom": "11:25:22"
                          },
                          {
                            "dayName": "Tuesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Wednesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Thursday",
                            "isActive": false
                          },
                          {
                            "dayName": "Friday",
                            "isActive": false
                          },
                          {
                            "dayName": "Saturday",
                            "isActive": false
                          },
                          {
                            "dayName": "Sunday",
                            "isActive": false
                          }
                        ],
                        "conversation_type": "blast",
                        "conversation_id": "fa73701f-2e0f-44dd-a483-389091cd1aab",
                        "media_data": {
                          "file": {
                            "name": "logo.jpg",
                            "size": 11438
                          },
                          "media": {
                            "media_file_mime": "image/jpeg",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                            "media_minio_bucket_name": "lol"
                          }
                        }
                      }
                    }
                  }
                ]
              }
            }
          ]
        },
        "Update Recurring Message": {
          title: 'Update Recurring Message',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Update Recurring Message for a given Phone Number Id. you can select only those Phone Number Id which is assigned to Logged In user.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of Phone Number Id assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#15`, detail: 'Click here to Get List of valid Scheduled Message Id.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Write#14`, detail: 'Click here to save and generate media data object.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Conversation Id.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#10`, detail: 'Click here to Get List of Blast Conversation Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/phone_numbers/{phone_id}/recurring_message`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "URI Parameters" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['phone_id', `Description`, `Phone ID is required for Create Schedule Message.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', 251]
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/phone_numbers/251/recurring_message`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "POST Request Body Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 4,
                        columns: [`id`, `Description`, `Valid Recurring Message Id for update.`]
                      },
                      {
                        columns: ['Type', 'Integer']
                      },
                      {
                        columns: ['Example', '151']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`message_content`, `Description`, `Message Content for a Scheduled Message.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'Create Recurring Schedule Via API.']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`recurring_schedule_message`, `Description`, `Array of Recurring Schedule Message must be valid. timeFrom must be in UTC 24HR format`]
                      },
                      {
                        columns: ['Type', 'Array of Object']
                      },
                      {
                        columns: ['Example', `
                        [
                          {
                              "isActive": true,
                              "dayName": "Monday",
                              "timeFrom": "11:25:22"
                          },
                          {
                              "isActive": false,
                              "dayName": "Tuesday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Wednesday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Thursday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Friday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Saturday"
                          },
                          {
                              "isActive": false,
                              "dayName": "Sunday"
                          }
                        ]
                      `]
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`media_data`, `Description`, `Media Data for save Media, you can create media data object by clicking on create media link.`]
                      },
                      {
                        columns: ['Type', 'Object of Media Data']
                      },
                      {
                        columns: ['Example', `{
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/5f54e336-bbae-425e-a3e1-32f2e4c94df3.jpeg",
                          "media_minio_bucket_name": "lol",
                          "media_file_name": "logo.jpg"
                        }
                      }`]
                      },
                      {
                        columns: ['Required', 'No']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_type`, `Description`, `Conversation Type must be either conversation or blast.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'conversation']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`conversation_id`, `Description`, `we need to put conversation_id if the Conversation Type is conversation than we need to select valid conversation id, if the Conversation Type is blast than we need to select valid blast id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', 'ed0c7623-1e3c-4507-82f0-67e94cfaa543']
                      },
                      {
                        columns: ['Required', 'Yes']
                      },
                      {
                        rowSpan: 4,
                        columns: [`is_past`, `Description`, `Is Past mean if we want to skip schedule message than we need to make is_past true.`]
                      },
                      {
                        columns: ['Type', 'boolean']
                      },
                      {
                        columns: ['Example', 'false']
                      },
                      {
                        columns: ['Required', 'No']
                      },
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request Body' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "id": 151,
                      "message_content": "Create Recurring Schedule Via API.",
                      "recurring_schedule_message": [
                        {
                          "isActive": true,
                          "dayName": "Monday",
                          "timeFrom": "11:25:22"
                        },
                        {
                          "isActive": false,
                          "dayName": "Tuesday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Wednesday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Thursday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Friday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Saturday"
                        },
                        {
                          "isActive": false,
                          "dayName": "Sunday"
                        }
                      ],
                      "media_data": {
                        "file": {
                          "name": "logo.jpg",
                          "size": 11438
                        },
                        "media": {
                          "media_file_mime": "image/jpeg",
                          "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                          "media_minio_bucket_name": "lol"
                        }
                      },
                      "is_past": false,
                      "conversation_type": "blast",
                      "conversation_id": "fa73701f-2e0f-44dd-a483-389091cd1aab"
                    }
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "id": 151,
                        "message_content": "Create Recurring Schedule Via API.",
                        "recurring_schedule_message": [
                          {
                            "dayName": "Monday",
                            "isActive": true,
                            "timeFrom": "11:25:22"
                          },
                          {
                            "dayName": "Tuesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Wednesday",
                            "isActive": false
                          },
                          {
                            "dayName": "Thursday",
                            "isActive": false
                          },
                          {
                            "dayName": "Friday",
                            "isActive": false
                          },
                          {
                            "dayName": "Saturday",
                            "isActive": false
                          },
                          {
                            "dayName": "Sunday",
                            "isActive": false
                          }
                        ],
                        "conversation_type": "blast",
                        "conversation_id": "fa73701f-2e0f-44dd-a483-389091cd1aab",
                        "media_data": {
                          "file": {
                            "name": "logo.jpg",
                            "size": 11438
                          },
                          "media": {
                            "media_file_mime": "image/jpeg",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/66221efa-e3fa-4718-a09d-e4e78808af27.jpeg",
                            "media_minio_bucket_name": "lol"
                          }
                        }
                      }
                    }
                  }
                ]
              }
            }
          ]
        },
        "Send SMS To Contact": {
          title: 'Send SMS To Contact',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Send SMS/MMS To Contact. From Phone Number must be available to the Logged In User.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of available Phone Number assigned to the Logged In user.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/sendsms?from={from}&to={to}&text={message}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request Param" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['from', `Description`, `Valid From Phone Number assigned to the Logged In user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '14043341185']
                      },
                      {
                        rowSpan: 3,
                        columns: ['to', `Description`, `Valid To Phone Number, Phone Number must be 11 digit.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '18287845279']
                      },
                      {
                        rowSpan: 3,
                        columns: ['text', `Description`, `SMS text that need to send.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'message']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/sendsms?from=14043341185&to=18287845279&text=message`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "error_message": "Message Send!!!"
                    }
                  },
                ]
              }
            }
          ]
        },
        "Send SMS/MMS To Blast": {
          title: 'Send SMS To Contact',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Send SMS To Blast. From Phone Number must be available to the Logged In User.",
                childTags: [
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#0`, detail: 'Click here to Get List of available Phone Number assigned to the Logged In user.' },
                  { key: P },
                  { key: A, link: `${API_FRONTEND_ACCESS_URL.MESSAGEVIEW_API_URL}#Read#9`, detail: 'Click here to Get List of Blast Conversation Id.' }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/sendsms?from={from}&blastId={blastId}&text={message}`]
                      },
                      {
                        columns: ['Method:', 'POST']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request Param" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: ['from', `Description`, `Valid From Phone Number assigned to the Logged In user.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', '14043341185']
                      },
                      {
                        rowSpan: 3,
                        columns: ['blastId', `Description`, `Valid Blast Conversation Id that is assigned to the Phone Number. Please use above link to get list of valid Blast Conversation Id.`]
                      },
                      {
                        columns: ['Type', 'uuid']
                      },
                      {
                        columns: ['Example', '4751c987-88e9-46c3-aa9f-f0ff4c76c973']
                      },
                      {
                        rowSpan: 3,
                        columns: ['text', `Description`, `SMS text that need to send.`]
                      },
                      {
                        columns: ['Type', 'String']
                      },
                      {
                        columns: ['Example', 'message']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Request URL' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: `${MV_API_URL}/sendsms?from=14043341185&blastId=4751c987-88e9-46c3-aa9f-f0ff4c76c973&text=message`
                  },
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "status_code": 200,
                      "error_message": "Message Send!!!"
                    }
                  },
                ]
              }
            }
          ]
        },
        "Upload Media": {
          title: 'Upload Media',
          parentTags: [
            {
              P: {
                detail: "This is a REST API for Upload Media."
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Request" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        columns: ['Endpoint:', `${MV_API_URL}/assets/upload_media`]
                      },
                      {
                        columns: ['Method:', 'PUT']
                      },
                      {
                        columns: ['Headers:', 'Authorization: Bearer <access_token>']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: IMG, detail: File_Upload_IMG },]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: "Put Request Form Data" },
                  {
                    key: TABLE,
                    rows: [
                      {
                        rowSpan: 3,
                        columns: [`files`, `Description`, `Upload File for Media, supported formats and size are [Maximum file size for JPEG, PNG, or PDF (up to 5 pages): 5MB
                                  Maximum file size for WAV, 3GP, or MP4: 300kB].`]
                      },
                      {
                        columns: ['Type', 'File']
                      },
                      {
                        columns: ['Required', 'Yes']
                      }
                    ]
                  }
                ]
              }
            },
            {
              SECTION: {
                childTags: [
                  { key: H3, detail: 'Response' },
                  { key: H4, detail: 'Example:' },
                  {
                    key: JSON, detail: {
                      "status": "ok",
                      "data": {
                        "media_data": {
                          "file": {
                            "name": "file-example-mp4-480-1-5mg_Cqhntu01.compressed.mp4",
                            "size": 207167
                          },
                          "media": {
                            "media_file_mime": "video/mp4",
                            "media_file_name": "file-example-mp4-480-1-5mg_Cqhntu01.compressed.mp4",
                            "media_minio_bucket_name": "lol",
                            "media_link": "https://messageviewminio-staging.brightlink.com/lol/1624885267869-file-example-mp4-480-1-5mg_Cqhntu01.compressed.mp4"
                          }
                        }
                      }
                    }
                  },
                ]
              }
            }
          ]
        },
      }
    }
  }
});
